/*-----------------------------------------------------------
//  Name: Apex - Popup & embed help framework
//  Description: All Controllers, Proxy Scripts, Handlers, react
//  Default WS Caching: 2hrs
//  Author: Amal Susainathan
//  Updated Date: 02/09/2021
//  Copyright: Microsoft Corporation, 2021
// -------------------------------------------------------*/

//fix for slidedown overflow issus
!(function (jQuery, origSlideDown) {
    jQuery.fn.slideDown = function (speed, easing, callback) {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        var origCallback;

        for (var i = 0, len = args.length; i < len; i++) {
            if (jQuery.isFunction(args[i])) {
                origCallback = args[i];
                args[i] = function () {
                    origCallback.call(this);
                    self.css('overflow', '');
                }
            }
        }
        if (!origCallback) {
            args.push(function () {
                self.css('overflow', '');
            });
        }
        return origSlideDown.apply(this, args);
    };
})(jQuery, jQuery.fn.slideDown);

/*-----------------------------------------------------------
//      AB GLOBAL VARIABLES
// -------------------------------------------------------*/
window.ab_glb = {
    ApexAPIEndPoint: '',
    CDNEndPoint: '',
    HelpUrl: '',
    HelpProduct: '',
    HelpProject: '',
    HelpMarket: '',
    HelpLanguage: '',
    HelpSku: '',
    HelpWinName: "_help",
    LocStrings: null,
    Version: 'V2',
    ShowContact: true,
    ShowCommunity: true,
    ShowFooter: true,
    ShowFlyoutInNewBrowser: true,
    UseAPEXhref: false,
    HideABOnScreen: false,
    BarOrDropDownOrCustom: 0,
    KnownIssueKey: '',
    BingYahooKey: '',
    HomeKey: '',
    CurrentQuery: '',
    FooterGlink: '#',
    ContactSupportGlink: '#',
    CommunityGlink: '#',
    IsBIDIMarket: false,
    SupportMarket: '',
    SupportOptions: null,
    Success: null,
    Failure: null,
    ContentRootElement: '#railContent',
    HelpOpened: false
};

window.apexHelpSpinOffWindow = false;

window.popup_glb = {
    HelpPopupLocalStrings: null,
    HelpUrl: '',
    HelpProduct: '',
    HelpProject: '',
    HelpMarket: '',
    HelpSku: '',
    HelpWinName: "_help",
    ShowContact: true,
    ContactSupportGlink: '#',
    ShowCommunity: true,
    CommunityGlink: '#',
    Success: null,
    Failure: null,
    Authorize: false
};

//----END OF GLOBAL VARIABLES -----------------------------

//--- BEGIN POPUP CONTROLLER ------------------------------//
/*-----------------------------------------------------------
//  Name: PopupCacheHandler
//  Description: Handles the clientside caching for the popups. 
// -------------------------------------------------------*/
PopupCacheHandler = function () {
    var topicSet = [];
    var topicResult = [];
    var index = 0;

    return {
        SetResultInCache: function (key, val) {
            topicResult[key] = val;
        },
        GetResultFromCache: function (key) {
            return topicResult[key];
        },
        AddTopicSet: function (val) {
            topicSet[index] = val;
            index++;
        },
        GetTopicIds: function () {
            var queryContentIds = '';
            var topicSetLength = PopupCacheHandler.GetTopicCount();
            if (topicSetLength > 0) {
                for (var i = 0; i <= topicSetLength - 1; i++) {
                    if (i == 0) {
                        queryContentIds = topicSet[i];
                    } else {
                        queryContentIds = queryContentIds + ',' + topicSet[i];
                    }
                }
            }

            return queryContentIds;
        },

        GetTopicCount: function () {
            return topicSet.length;
        }
    };
}();

/*-----------------------------------------------------------
//  Name: PopupController
//  Description: Controller for the popups. 
// -------------------------------------------------------*/
PopupController = function () {
    var initialPosition = "";
    var initializePopupGlobals = false;
    var targetObj = "";
    var isDraggable = false;

    var bindTopicEvents = function () {

        if ($("#_helpcontainer a.HelpTopic") != undefined && $("#_helpcontainer a.HelpTopic").length > 0) {

            $("#_helpcontainer a.HelpTopic").click(function (e) {
                //if (e.preventDefault) { e.preventDefault(); }
                //if (e.stopPropagation) { e.stopPropagation(); }

                var helpkey = $(this).attr('query');
                var project = window.popup_glb.HelpProject;

                var viewId = $('[RailViewID]')[0] == undefined ? 'none' : $('[RailViewID]')[0].attributes['railviewid'].value;
                var project = window.popup_glb.HelpProject == '' ? window.popup_glb.HelpProduct : window.popup_glb.HelpProject;
                PopupILog.LogAriaEvent('popup', project, window.popup_glb.HelpMarket, helpkey, '', '', 'page', viewId);
                $("#_helpcontainer").hide();
                //return false;
            });
        }
    };

    var setForBidi = function (offset) {
        if (getDirection(document.body) == "rtl") {
            var padding = $("#_helpcontainer").height() - 85;
            if (offset > 0) { offset = 0; } else { offset -= 20; }
            var left = $("#_helpcontainer").position().left - $("#_helpcontainer").width() - 30 - offset;
            if (left <= 5) left = 5;
            $("#_helpcontainer").css({ "direction": "rtl", "unicode-bidi": "bidi-override", "float": "left", "left": left });
            $(".popuphelpwindow  .popuphelp-drag-contentarea").css("padding-bottom", padding);
            $(".popuphelpwindow .conceptual_title, .popuphelpwindow .content_title, .popuphelpwindow .conceptual_section, .popuphelpwindow li, .popuphelpwindow ul, .popuphelpwindow .conceptual_body_none, .popuphelpwindow .popup_footer, .popuphelpwindow .ab-thumbTitle, .popuphelpwindow .apex-thumb-up").css({ "float": "right", "text-align": "right", "margin-right": "15px" });
        };
    };

    var handleSingleContentSuccess = function (singledata) {
        //debugger;
        if (window.popup_glb.Authorize == true) {
            singledata = $.parseJSON(singledata);
        }
        if (singledata == null || singledata.Content == null) { return false; }
        var contentHtml = singledata.Content.Content; // singledata.Contents.replace(/window.ab_glb./g, 'window.popup_glb.').replace(/HelpAnswerBar/g, 'PopupControl');
        contentHtml = contentHtml.replace(/window.ab_glb./g, 'window.popup_glb.').replace(/HelpAnswerBar/g, 'PopupControl');

        //replace images associating from xslt transfermation
        contentHtml = replacePlusMinusSearchImageSource(contentHtml);

        $(".popuphelp-drag-contentarea").html(contentHtml);
        $.each($('a[href_new]'), function (index, elem) {
            var val = $(elem).attr('href_new');
            var token = '/';
            var viewId = $('[RailViewID]')[0] == undefined ? 'none' : $('[RailViewID]')[0].attributes['railviewid'].value;
            if (window.popup_glb.HelpUrl.match("/$") == "/") token = '';
            $(elem).attr('href', window.popup_glb.HelpUrl + token + val + '/' + window.popup_glb.SupportMarket + '/#ext:' + viewId);
            $(elem).attr('target', '_apexPlatformHelp');
        });
        PopupCacheHandler.SetResultInCache(singledata.ContentID, $(".popuphelp-drag-contentarea").html());
        bindTopicEvents();
        var helpContainer = "#_helpcontainer";
        var helpWindow = $(helpContainer);
        setContainerPosition(helpWindow);
        if (pageHasIframe()) {
            $('.railhelp_head').removeClass('rh_hover');
        }
        isDraggable = false;
        enableDraggable();
        //Add popup title to aria-label
        var helpPopupTitle = $("#_helpcontainer h1").length ? $("#_helpcontainer h1").text() + " " : "";
        $("#_helpcontainer").attr({ "aria-label": helpPopupTitle + "popup dialog", "role": "dialog" });
        var lastElementNoSupport = RailHelpController.FindLastVisibleElement($('#_helpcontainer'));
        var firstElem = $("#_helpcontainer #_helpPopupCloseLink");
        var lastElem = $(lastElementNoSupport);
        ApexPlatform.ApexTrapFocus(firstElem, lastElem);
        firstElem.focus();
        
        if (window.apex_glb && typeof window.apex_glb.onPopupOpen === 'function') {
            window.apex_glb.onPopupOpen(document.querySelector('#_helpcontainer'));
        }
        return false;
    };

    var handleVideoContentSuccess = function (singledata) {
        if (singledata.success == true) {
            if (singledata.Contents == null) { return false; }
            var contentHtml = ''; // singledata.Contents.replace(/window.ab_glb./g, 'window.popup_glb.').replace(/HelpAnswerBar/g, 'PopupControl');
            if (singledata.Contents.HelpContent == null) {
                contentHtml = singledata.Contents;
            } else {
                if (singledata.Contents.HelpContent.Content != null) {
                    contentHtml = singledata.Contents.HelpContent.Content;
                }
            }

            var found = $(contentHtml).find(".abLaunchVideo");
            if (found != null) {
                $(found).helpVideoWindow();
                $(found).triggerHandler("click");
                $(found).unbind();
            }
        }
        return false;
    };

    var handleContentFailure = function (data) {
    };

    var enableDraggable = function () {
        try {
            if (!pageHasIframe()) {
                applyDraggable();
            }
            else {
                $(".popuphelpwindow #drag_handle").hide();
            }
        }
        catch (err) { }
    };

    var pageHasIframe = function () {
        return ($('iframe').length > 0);
    };

    var applyDraggable = function () {
        try {
            $("#_helpcontainer").bind('mousemove', function () {
                var containerWidth = $(window).width() - $(this).outerWidth();
                var containerHeight = $(window).height() - $(this).outerHeight();
                try {
                    $(this).draggable({
                        greedy: true,
                        handle: 'div.railhelp_drag',

                        containment: // Set containment to current viewport
                            [$(document).scrollLeft(),
                            $(document).scrollTop() + 100,
                            $(document).scrollLeft() + containerWidth,
                            $(document).scrollTop() + containerHeight],
                        stop: function (event, ui) {
                            //HelpControllerEx.InstrumentLink("WindowDragged");
                            //TODO: Log Aria
                        }
                    });
                }
                catch (e) { }
            }).draggable({ scroll: false });
            isDraggable = true;
        }
        catch (ex) { };
    };

    var getParentWindow = function () {
        var parentWindow = $(window);
        return parentWindow;
    };

    var setContainerPosition = function (container) {
        var widthContainer = 310;
        var zIndex = 1000;
        if ($('#popupcontainerId') != null) {
            widthContainer = $('#popupContainerid').attr('popupwidth');
            if (typeof (widthContainer) !== "undefined") {
                if (widthContainer < 310) {
                    widthContainer = 310;
                }
            }
            else widthContainer = 310;
            zIndex = $('#popupContainerid').attr('zindex');
            if ((typeof (zIndex) == "undefined") || (zIndex == '')) {
                zIndex = 1000;
            }
        }
        var parentWindow = getParentWindow(),
            leftoffset = 0,
            topoffset = 0,
            scrollbarSize = 20,
            rightOffset = ($(window).width() - ($(targetObj).offset().left + 18)),
            scrollbarLiveArr = getScrollbarLive(window),
            scrollRightLive = scrollbarLiveArr[0],
            scrollBottomLive = scrollbarLiveArr[1],
            movepopupLeft = (rightOffset < widthContainer);// && scrollRightLive;

        if (PopupController.currentPopupTrigger) {
            initialPosition = getElementPosition(PopupController.currentPopupTrigger);
        }
        var windowWidth = $(window).width();
        var leftPosition =
            (windowWidth - (initialPosition.left - $(window).scrollLeft()) - widthContainer < 0)
                ? Math.max($(window).scrollLeft(), windowWidth + $(window).scrollLeft() - widthContainer)
                : initialPosition.left + targetObj.width() + 2 - leftoffset + initialPosition.paddingLeft;

        container.width(widthContainer);

        var windowHeight = $(window).height();
        var windowHeightOffset = 0;
        var helpTopOffset = 0;
        var helpHeight = container.height();
        var screenInitialTopPosition = initialPosition.top - helpTopOffset - $(window).scrollTop();
        var lowestPoint = initialPosition.top - helpTopOffset + helpHeight;
        var screenLowestPoint = lowestPoint - $(window).scrollTop();
        var topPosition = initialPosition.top - helpTopOffset;

        //Fix for firefox offset by 60
        var vernums = $.fn.jquery.split('.');
        //var isIE = /trident/.test(navigator.userAgent.toLowerCase());
        if (parseInt(vernums[0]) > 0 && parseInt(vernums[1]) > 8) {
            $.browser.mozilla = /firefox/.test(navigator.userAgent.toLowerCase());

        }

        //if ($.browser.mozilla && isIE == false)
        //    topPosition += 56;

        if ($(".container-fluid").length > 0) windowHeightOffset = $(".container-fluid").height();

        if ((screenLowestPoint > (windowHeight - windowHeightOffset)) || (screenInitialTopPosition < 0)) {
            if (screenInitialTopPosition > 0) {
                if ($(".container-fluid").length > 0) topoffset += ($(".container-fluid").height() - 20);
                topPosition = screenInitialTopPosition + windowHeight - screenLowestPoint - 10 - topoffset;
            }
            var currentWindowTop = $(parentWindow).scrollTop();
            topPosition = topPosition + currentWindowTop;
            if (topPosition < currentWindowTop) topPosition = currentWindowTop;
        }

        //if there is a scroll on right or bottom (offset it)
        if (movepopupLeft) {
            leftPosition = initialPosition.left - widthContainer - 3;
        }

        let helpWidth = container.width();
        if (helpWidth > windowWidth) {
            helpWidth = windowWidth;
        }

        if (leftPosition < 0) {
            leftPosition = 0;
        } else if (leftPosition + helpWidth > windowWidth) {
            leftPosition = windowWidth - helpWidth;
        }

        if (topPosition + helpHeight > windowHeight) {
            topPosition = windowHeight - helpHeight;
        }

        container.css({ top: topPosition, left: leftPosition, 'z-index': zIndex, width: helpWidth });
        setForBidi(leftPosition - initialPosition.left);
        $(".popuphelp_head .ab_supportDivider").width(widthContainer - 305);

        container.show();
        $('div#_helpcontainer.popuphelpwindow').focus();
    };

    var getScrollbarLive = function (w) {
        var d = w.document,
            c = d.compatMode,
            r = c && /CSS/.test(c) ? d.documentElement : d.body;
        if (typeof w.innerWidth == 'number') {
            return [w.innerWidth > r.clientWidth, w.innerHeight > r.clientHeight];
        } else {
            return [r.scrollWidth > r.clientWidth, r.scrollHeight > r.clientHeight];
        }
    };

    var getElementPosition = function (element) {
        var result = { left: element.offsetLeft, top: element.offsetTop, paddingLeft: 0 };
        var ancestor = element.parentNode;
        var matrix = $(element).css('transform').replace(/[^0-9\-.,]/g, '').split(',');
        var translateX = parseInt((matrix[12] || matrix[4]), 10);
        var translateY = parseInt((matrix[13] || matrix[5]), 10);

        while (ancestor && ancestor != document && ancestor.tagName.toLowerCase() != 'body' && ancestor.tagName.toLowerCase() != 'html') {
            result.left -= ancestor.scrollLeft;
            result.top -= ancestor.scrollTop;
            if (ancestor == element.offsetParent)
                break;
            ancestor = ancestor.parentNode;
        }
        if (element.offsetParent) {
            var parentOffset = getElementPosition(element.offsetParent);
            result.left += parentOffset.left;
            result.top += parentOffset.top;
        }
        result.paddingLeft = 0;

        try {
            result.paddingLeft = parseInt($(element).css("padding-left").replace('px', ''))
        }
        catch (e) { };
        if (translateX != undefined && isFinite(translateX)) {
            result.left += translateX;
        }
        if (translateY != undefined && isFinite(translateY)) {
            result.top += translateY;
        }

        return result;
    };

    var queryObj = function (id, market, product, project, sku, querytype, queries, filter, contenttype, viewids, url, token, method) {
        this.ContentId = id;
        this.Product = product;
        this.Project = project;
        this.QueryType = querytype;
        this.Queries = queries;
        this.Filter = filter;
        this.Market = market;
        this.Sku = sku;
        this.ContentType = contenttype;
        this.ViewIDs = viewids;
        this.ViewId = viewids;
        this.Url = url;
        this.Token = token;
        this.Method = method;
    };

    //Update Plusminus image base url
    var replacePlusMinusSearchImageSource = function (html) {
        var result = html;
        var collapse = '/resources/neutral/images/railbar_collapse_rest.gif';
        var expand = '/resources/neutral/images/railbar_expand_rest.gif';
        var search = '/resources/neutral/images/search_icon.gif';
        result = replaceAll(result, collapse, window.popup_glb.HelpUrl + collapse);
        result = replaceAll(result, expand, window.popup_glb.HelpUrl + expand);
        result = replaceAll(result, search, window.popup_glb.HelpUrl + search);
        return result;
    };

    var replaceAll = function (input, replace, withThis) {
        return input.replace(new RegExp(replace, 'g'), withThis);
    };

    var getDefaultLocValues = function () { //default en-us.
        var locStr = '{"LocStrings":{"About":"About this page","Help":"Help", "Community":"Community","How":"How do I?","Search":"Search Help","Videos":"Watch a video","New":"Whats New","RCQ":"Everybody asking(RCQ)","Issues":"Known Issues","Chat":"Contact support","Support":"Support","Loading":"Loading","More":"More...","Less":"Less...","Rating1":"Absolutely awful!","Rating2":"Really? You can do better…","Rating3":"It’s alright.","Rating4":"Nicely done.","Rating5":"Pure genius!","QueryDefault":"Search Help","Yes":"Yes","No":"No","DidHelpYou":"Did this help you?", "ShowAB":"Show Answer Bar", "HideAB":"Hide Answer Bar", "Content":"content", "Video":"video", "Back":"Back","Next":"Forward", "OF":"of", "CopyUrl":"Copy Url", "EmailUrl":"Email Url", "Pinned":"Keep on top", "UnPinned":"Not on top","CommunityText":"Community", "Header":"Bing Ads Help","PrintTopic":"Print article","CommunityFooter":"Not finding what you are looking for? Check out the {0}Bing Ads Community blog and forums.{1}"}}';

        var dataNew = null;
        if (typeof JSON != 'undefined') {
            dataNew = jQuery.parseJSON(locStr);
        }
        else {
            dataNew = eval("(" + locStr + ")");
        }

        window.popup_glb.HelpPopupLocalStrings = dataNew.LocStrings;
    };

    var setContactSupportLink = function () {
        if ($('a[href$="pid=Advertising_Chat"]:first').length > 0) {
            $('a[href$="pid=Advertising_Chat"]:first').attr('href', window.popup_glb.ContactSupportGlink);
        }
    };

    var getDirection = function (element) {
        var result = null;
        if (element) {
            if (window.getComputedStyle) {
                result = window.getComputedStyle(element, null).direction;
            } else if (element.currentStyle) {
                result = element.currentStyle.direction;
            }
        }

        return result;
    };

    //Close popup window when press ESC key
    var clickEscKeyPopupCheck = function (e) {
        if (e.preventDefault) { e.preventDefault(); }
        var el = e.target;
        var popup = $('.popuphelpwindow:visible')[0];
        if (popup == undefined) return true;

        if (window.apex_glb && typeof window.apex_glb.onPopupClose === 'function') {
            window.apex_glb.onPopupClose();
        }

        while (true) {
            if (el == popup) {
                if (e.which == 27) {
                    if (e.stopPropagation) { e.stopPropagation(); }
                    $(document).unbind('keyup.popuphelpwindow');
                    $('#_helpPopupCloseLink').click();
                    return false;
                }
                else {
                    return true;
                }
            } else if (el == document) {
                $(".popuphelpwindow").hide();
                //HelpControllerEx.InstrumentLink("Close", "1");
                //TODO: Log Aria
                return false;
            } else {
                el = $(el).parent()[0];
            }
        }
    };

    //Close popup window when user clicks outside of popup window
    var clickOutsidePopupCheck = function (e) {
        if (e.preventDefault) { e.preventDefault(); }
        $(document).unbind('mousedown.popuphelpwindow');
        var el = e.target;
        var popup = $('.popuphelpwindow:visible')[0];
        if (popup == undefined) return true;

        if (window.apex_glb && typeof window.apex_glb.onPopupClose === 'function') {
            window.apex_glb.onPopupClose();
        }

        while (true) {
            if (el == popup) {
                return true;
            } else if (el == document) {
                $(".popuphelpwindow").hide();
                //HelpControllerEx.InstrumentLink("Close", "1");
                //TODO: Log Aria
                return false;
            } else {
                el = $(el).parent()[0];
            }
        }
    };

    var enableTheme = function (theme) {
        if (theme != undefined && theme != '') {
            var popThemeCssPath = window.popup_glb.HelpUrl + "/resources/popup/styles/PopupStyles.min-" + theme + ".css?v=2.00024";
            var headId = $('head')[0];
            var link = '<link href="' + popThemeCssPath + '" rel="stylesheet" type="text/css" />';
            $(link).appendTo(headId);
        }
    };

    var enableRTLLanguage = function () {
        var rtl = window.popup_glb.HelpMarket.toLowerCase().substring(0, 3);
        var idx = $.inArray(rtl, ["ar-", "he-", "fa-"]);
        if (idx > -1) {
            //var popRTLCssPath = window.popup_glb.HelpUrl + "/resources/popup/styles/PopupStyles.rtl.min.css?v=2.00020";
            var popRTLCssPath = window.popup_glb.HelpUrl + "/resources/popup/styles/PopupStyles.rtl.css?v=2.00024";
            var headId = $('head')[0];
            var link = '<link href="' + popRTLCssPath + '" rel="stylesheet" type="text/css" />';
            $(link).appendTo(headId);
        }
    };
    return {
        currentPopupTrigger: null,
        setContainerPosition: setContainerPosition,
        GetGlobalHelpInformation: function () {
            window.popup_glb.HelpUrl = $.trim($("#popupInputs").attr("Helpurl"));
            window.popup_glb.HelpProduct = $.trim($("#popupInputs").attr("Product"));
            window.popup_glb.HelpProject = $.trim($("#popupInputs").attr("Project"));
            window.popup_glb.HelpMarket = $.trim($("#popupInputs").attr("Market"));
            window.popup_glb.HelpSku = $.trim($("#popupInputs").attr("Sku"));
            if (window.popup_glb.SupportMarket == undefined || $.trim(window.popup_glb.SupportMarket) == "") {
                window.popup_glb.SupportMarket = window.popup_glb.HelpMarket;
            }
            var theme = $.trim($("#popupInputs").attr("Theme"));
            if (typeof (window.ab_glb) != 'undefined' && window.ab_glb.LocStrings != null) {   // this is to piggyback on the call if made by AnswerBar as it essentially is the same call.
                window.popup_glb.HelpPopupLocalStrings = window.ab_glb.LocStrings;
                window.popup_glb.HelpProject = window.ab_glb.HelpProject;
                window.popup_glb.ShowContact = window.ab_glb.ShowContact;
                window.popup_glb.ContactSupportGlink = window.ab_glb.ContactSupportGlink;
                window.popup_glb.ShowCommunity = window.ab_glb.ShowCommunity;
                window.popup_glb.CommunityGlink = window.ab_glb.CommunityGlink;
                setContactSupportLink();
            }

            //adding the css file. May need to move it out to a separate function.
            //var popupCssPath = window.popup_glb.HelpUrl + "/resources/popup/styles/PopupStyles.min.css?v=2.00023";
            //var link = '<link href="' + popupCssPath + '" rel="stylesheet" type="text/css" />';
            //var headId = $('head')[0];
            //$(link).appendTo(headId);
            //enableTheme(theme);
            enableRTLLanguage();
        },

        PopupJsClick: function (obj) {
            if (obj.stopPropagation) {
                obj.stopPropagation();
            }
            else if (window.event) {
                window.event.cancelBubble = true;
            }

            var settings = window.popup_glb;
            jQuery.extend(settings, { target: obj, contentID: obj.getAttribute("topic"), helpType: obj.getAttribute("type") });
            PopupController.currentPopupTrigger = obj;
            PopupController.HelpLinkClicked(obj, settings);
        },

        HelpLinkClicked: function (inst, instanceSettings) {
            var loadHelpContent = function (element, url, contentId) {
                var contentArea = element.find(".popuphelp-drag-contentarea");
                contentArea.html(settings.loadingHTML); //.css("overflow", "hidden");
                var helpresult = null;
                var attr = $(inst).attr('content');
                if (typeof attr !== "undefined" && attr !== undefined) {
                    helpresult = decodeURIComponent(attr);
                }
                else {
                    helpresult = PopupCacheHandler.GetResultFromCache(contentId);
                }
                if (helpresult != null && helpresult != undefined) {
                    $(".popuphelp-drag-contentarea").html(helpresult);
                    bindTopicEvents();
                }
                else {
                    var proxy = new PopupProxy();
                    proxy.GetContent(contentId, handleSingleContentSuccess, handleContentFailure, "");
                }
            };

            var defaultSettings = {
                resizable: false,         // whether the window can be resized TRUE/FALSE
                helpUrl: null,            // url to get help content
                helpCSS: "popuphelpwindow",    //CSS of dialog window container
                closeImageURL: "",        //URL of close image 
                closeText: "",            //title for close image
                loadingHTML: "",          // loading panel
                lessText: "",             // localized less text, default to english
                moreText: "",             // localized more text, default to english
                width: null,              //window width
                height: null,             // window height
                draggable: true,          // should help window be draggable
                baseHelpUrl: "",          //URL for help haldler
                market: "",              //Market such as en-us
                project: "",              //Project name based on user security level
                contentID: "",             //content PID,
                helpType: "helppopuup"             //content PID,
            };

            var settings = $.extend({}, defaultSettings, instanceSettings || {});

            if (instanceSettings.helpType == "helppopup") {
                targetObj = $(settings.target);
                var helpContainer = "#_helpcontainer";
                var helpImage = "#_helpPopupCloseLink";
                var helpWindow = $(helpContainer);
                helpWindow.remove();
                //var contact = window.popup_glb.HelpPopupLocalStrings.Chat;
                //if (window.popup_glb.HelpMarket.toLowerCase().indexOf("en-") <= -1) {
                //    contact = window.popup_glb.HelpPopupLocalStrings.Support;
                //}

                var closeBtnSvg = `
                <svg fill="currentColor"
                    width="32px"
                    height="32px"
                    viewBox="0 0 64 64"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M32.033,29.19l15.55,-15.55l2.863,2.863l-15.55,15.55l15.55,15.55l-2.863,2.863l-15.55,-15.55l-15.55,15.55l-2.863,-2.863l15.55,-15.55l-15.55,-15.55l2.863,-2.863l15.55,15.55Z" />
                </svg>
                `;
                var domwindowdata = '<div id="_helpcontainer" tabindex="0" class="' + settings.helpCSS + '">';
                domwindowdata += '<div class="popup_wrapper">';
                domwindowdata += `<div class="popuphelp_head"><div id="drag_handle" class="railhelp_drag rh_hover"></div><span  id="_helpPopupCloseLink" tabindex="0" aria-label="close popup" class="railhelp_close" role="button">
                ${closeBtnSvg}
                </span>`;
                //domwindowdata += '<div class="ab_supportNav"><div id="ab_contact" class="ab_contact"><span id="ab_contact_img"></span><span  id="ab_contact_txt">' + contact + '</span></div>';
                //domwindowdata += '</div></div>';
                domwindowdata += '</div>';
                domwindowdata += '<div class="popuphelp-drag-contentarea"></div>';
                domwindowdata += '<div id="popuprating" class="popup_footer"></div>';
                domwindowdata += '</div>'; // popup_wrapper div end
                domwindowdata += '</div>';
                var $elem = $(domwindowdata);
                initialPosition = getElementPosition(inst);

                if ($(helpContainer).length > 0) {
                    $(helpContainer).remove();
                }
                $(document.body).append($elem);

                helpWindow = $(helpContainer);
                $(helpImage).bind("click", function () {
                    $(helpContainer).hide();
                    var elem = $(helpImage).data("element");
                    $(elem).focus();
                    $(helpImage).data("element", "");
                    var viewId = $('[RailViewID]')[0] == undefined ? 'none' : $('[RailViewID]')[0].attributes['railviewid'].value;
                    var project = window.popup_glb.HelpProject == '' ? window.popup_glb.HelpProduct : window.popup_glb.HelpProject;
                    PopupILog.LogAriaEvent('popup', project, window.popup_glb.HelpMarket, instanceSettings.contentID, '', '', 'close', viewId);
                    return false;
                });
                $(helpImage).unbind('keypress');
                $(helpImage).bind('keypress', function (event) {
                    if (event.preventDefault) { event.preventDefault(); }
                    if (event.which === 13) {
                        $(event.target).trigger('click');
                    }
                });
                enableDraggable();
                //////PopupChromeController.EnableChromeSupportingLinksAndButtons();
                ////////bind  community, contact support 
                //////$(".popuphelp_head #ab_contact, .popuphelp_head #ab_community").click(function(e) {
                //////    if (e.preventDefault) {
                //////        e.preventDefault();
                //////    }
                //////    var logctxt = 'pp:' + window.popup_glb.HelpMarket + ':' + $("#popupInputs").attr("RatingID");
                //////    return PopupChromeController.ButtonHandler(e.target.id, logctxt);
                //////});
                //if (helpWindow.draggable && settings.draggable) helpWindow.draggable();
                if (settings.width) helpWindow.width(settings.width);
                helpWindow.find(".popuphelp-drag-contentarea").html("");
                helpWindow.css("visibility", "visible");

                helpWindow.show();
                //$(helpImage).focus();
                $(helpImage).data("element", inst);
                loadHelpContent(helpWindow, settings.helpUrl, settings.contentID);
                setContainerPosition(helpWindow);
                //log aria
                var viewId = $('[RailViewID]')[0] == undefined ? 'none' : $('[RailViewID]')[0].attributes['railviewid'].value;
                var project = window.popup_glb.HelpProject == '' ? window.popup_glb.HelpProduct : window.popup_glb.HelpProject;
                PopupILog.LogAriaEvent('popup', project, window.popup_glb.HelpMarket, instanceSettings.contentID, '', '', 'page', viewId);
                $(document).bind('mousedown.popuphelpwindow', clickOutsidePopupCheck);
                $(document).bind('keyup.popuphelpwindow', clickEscKeyPopupCheck);
            }

        }
    };
}();

var PopupProxy = function () {
};

PopupProxy.prototype = {
    //performs GetContent
    //GetContents: function (queryObj, success, fail, before) {
    //    debugger;
    //    //Hack for param
    //    queryObj.Project = queryObj.Product;
    //    queryObj.Method = "GetContents";
    //    var url = window.popup_glb.HelpUrl + "/ApexContentHandler.ashx";
    //    $.ajax({
    //        url: url,
    //        data: queryObj,
    //        crossDomain: true,
    //        dataType: 'jsonp',
    //        cache: false,
    //        success: success,
    //        fail: fail,
    //        timeout: 60000
    //    });
    //},

    //performs GetContent
    GetContent: function (query, success, fail, before) {
        //debugger;
        //performs GetContent


        var input = {
            'project': apex_glb.Project,
            'language': apex_glb.Market,
            'query': query,
            'asRow': 'popup',
            'method': 'popup'
        };
        var url = window.popup_glb.HelpUrl + "/api/" + window.apex_glb.APIController + "/";
        if (window.popup_glb.Authorize == true) {
            url = "/ApexHelp/HelpContent";
        }
        $.ajax({
            url: url,
            data: input,
            //method: "POST",
            //indexValue: indexValue,
            contentType: 'application/json',
            crossDomain: true,
            // dataType: 'jsonp',
            cache: false,
            success: success,
            error: fail,
            timeout: 60000
        });

    },

    //performs getting the localized values.
    GetLocalizedCommonValues: function (success, fail, before) {
        var viewId = 'default';
        var input = {
            'project': window.popup_glb.HelpProject,
            'language': window.popup_glb.HelpMarket,
            'view': viewId
        };

        var url = window.popup_glb.Authorize == true ? "/ApexHelp/HelpConfig" : window.popup_glb.HelpUrl + "/api/" + window.apex_glb.APIController + "/ApexConfig";
        $.ajax({
            url: url,
            data: input,
            //method: "POST",
            contentType: 'application/json',
            crossDomain: true,
            // dataType: 'jsonp',
            cache: false,
            success: success,
            error: fail,
            timeout: 60000
        });
    }
};

//
// Create Popup PLUG-IN
//

(function ($) {
    $.fn.CreatePopup = function (options) {
        var inputmarkup = '<INPUT ID="popupInputs" CLASS="popupInputs" type="hidden"></INPUT>';
        if ($("#popupInputs").length < 1) {
            $(inputmarkup).appendTo($('body')[0]);
        }
        var opts = $.extend({}, $.fn.CreatePopup.defaults, options);
        window.popup_glb.Authorize = opts.Authorize;
        $.fn.CreatePopup.storedata($(this), opts);
        //if (PopupController.initializePopupGlobals) {
        //    PopupController.GetGlobalHelpInformation();
        //}
        //PopupController.initializePopupGlobals = true;
    };

    $.fn.CreatePopup.defaults = {
        helpUrl: 'https://adcenterhelp.microsoft.com',
        sku: 'SelfServe',
        project: '',
        product: '',
        market: 'en-US',
        language: '',
        enable: 'true',
        theme: '',
        success: null,
        failure: null,
        draggable: true,
        Authorize: false
    };

    $.fn.CreatePopup.storedata = function (e, o) {
        //debugger;
        if (o.project == undefined || $.trim(o.project) == "") {
            o.project = "";
        }
        if ((o.product == undefined || $.trim(o.product) == "") && $.trim(o.project) != "") {
            o.product = o.project;
        }
        if (o.language == undefined || $.trim(o.language) == "") {
            o.language = o.market;
        }
        $('#popupInputs').attr('HelpUrl', o.helpUrl);
        $('#popupInputs').attr('Sku', o.sku);
        $('#popupInputs').attr('Project', o.project);
        $('#popupInputs').attr('Product', o.product);
        $('#popupInputs').attr('Market', o.language);
        $('#popupInputs').attr('Language', o.language);
        $('#popupInputs').attr('SupportMarket', o.SupportMarket);
        if (o.theme !== '') {
            $('#popupInputs').attr('Theme', o.theme);
        }
        window.popup_glb.Success = o.success;
        window.popup_glb.Failure = o.failure;
        window.popup_glb.Authorize = o.Authorize;
    };

})(jQuery);


jQuery(document).ready(function () {
    //if (PopupController.initializePopupGlobals) {
    //    PopupController.GetGlobalHelpInformation();
    //} else {
    //    PopupController.initializePopupGlobals = true;
    //}

    $(document).off('click', 'a.popupbutton, a.videobutton');
    //$(document).on('click', 'a.popupbutton, a.videobutton', function (e) {
    //    if (e.preventDefault) { e.preventDefault(); }
    //    if (e.stopPropagation) { e.stopPropagation(); }
    //    PopupController.PopupJsClick(e.target);
    //});
    document.addEventListener('click', function (e) {
        for (var target = e.target; target && target != this; target = target.parent) {
            if (target.matches('a.popupbutton, a.videobutton')) {
                if (e.preventDefault) { e.preventDefault(); }
                if (e.stopPropagation) { e.stopPropagation(); }
                PopupController.PopupJsClick(e.target);
            }
        }

    }, true);

    window.addEventListener('resize', () => {
        const visibleHelpContainer = $('#_helpcontainer:visible');
        if (visibleHelpContainer.length > 0) {
            PopupController.setContainerPosition(visibleHelpContainer);
        }
    });
});


/***********************************/
/** APEX Interaction Variables    **/
/***********************************/

function PopupILog() { }

PopupILog.LogAriaEvent = function (source, project, language, query, filename, row, logType, view) {
    //Log an event using fluent syntax for page view.
    //if (window.popup_glb.Authorize == true) return;
    query = (query == null || query === "") ? 'NONE' : query;
    filename = (filename == null || filename === "") ? 'NONE' : filename;
    row = (row == null || row === "") ? 'NONE' : row;
    logType = (logType == null || logType === "") ? 'NONE' : logType;
    view = (view == null || view === "") ? 'NONE' : view;
    var url = window.popup_glb.HelpUrl + "/api/logaria";
    var referer = window.location.href;

    var input = {

        'name': 'popup',
        'source': source,
        'project': project,
        'language': language,
        'filename': filename,
        'row': row,
        'query': query,
        'logtype': logType,
        'view': view,
        referer: referer
    };

    //self.setNavItem(nav);
    $.ajax({
        url: url,
        type: "GET",
        data: input,
        cache: false
    }
    );
};

//--- END POPUP CONTROLLER ------------------------------//

/*-----------------------------------------------------------
//  Name: ApexVideoHandler
//  Description: ApexVideoHandler
//
// -------------------------------------------------------*/
ApexVideoHandler = function () {
    //private variable
    var isOpen = false;
    var buildVideoOverlayHtml = function () {
        var html = [
            '<div class="abOverlayBgCover"></div>',
            '<div id="abOverlayBox" class="abOverlayBox">',
            '	<div id="abOverlayContent">',
            '		<div id="abOverlayHead"><span id="abOverlayClose" tabindex="0" role="button" aria-label="Video Close"></span></div>',
            '		<div id="abOverlayVideo"></div>',
            '	</div>',
            '</div>'];
        //var root = RailHelpController.GetRootElementId();
        if ($('.abOverlayBgCover').length == 0) {
            $(html.join('')).insertAfter('body');

            // Unable to tab out of iframe
            var firstElem = $("#abOverlayClose");
            var lastElem = $("#iframeVideo");
            ApexPlatform.ApexTrapFocus(firstElem, lastElem);
        }
    };

    var showOverlayBox = function () {

        //if box is not set to open then don't do anything 
        if (isOpen == false) { return; }

        // set the properties of the overlay box, the left and top positions
        $('.abOverlayBox').css({
            display: 'block',
            left: ($(window).width() - $('.abOverlayBox').width()) / 2,
            top: (($(window).height() - $('.abOverlayBox').height()) / 2 - 20) + $(this).scrollTop(),
            position: 'absolute',
            'z-index': '2002'
        });


        // set the window background for the overlay. i.e the body becomes darker
        $('.abOverlayBgCover').css({
            display: 'block',
            width: $(document).width(),
            height: $(document).height(),
            'z-index': '2001'
        });
    };

    var doOverlayOpen = function (src, elem) {
        //set status to open
        isOpen = true;

        // REVISIT BUG FIX - Ajax call for title attribute
        // cross site scripting error
        /*
        var endpnt = apex_glb.EndPoint;
        var prd = apex_glb.Project;
        var mkt = apex_glb.Market;

        var currentURL = endpnt + 'resources/targeted/' + prd + '/' + mkt + '/config_VideoTopics.JSON';

        $.ajax({
            url: currentURL,
            type: "get",
            dataType: "json", //jsonp
            crossDomain: true,
            success: function (data) {
                //debugger;
                console.log("success ajax data: " + data);
                for (var i = 0; i < data.length; i++) {
                    //if (data[i].VideoId == uuid) {
                    //    $('#videoTitle').html(data[i].Title);
                    //    $('#videoDesc').html(data[i].Summary);
                    //    $('#videoFrame iframe').attr("title", data[i].Title + " Video Player");
                    //    break;
                    //}
                    console.log("success ajax data inside: " + data);
                }

            },
            error: function (e) {
                //debugger;
                console.log("fail ajax:" + e );
            }
        });
        */

        var html = '<iframe id="iframeVideo" allowfullscreen name="iframeVideo" scrolling="no" src="" width="' + 600 + '"px" height="' + 470 + '"px" frameborder="0" style="margin-bottom: 8px;" title="Video Container"></iframe>';

        if ($("#iframeVideo").length === 0) {
            $(html).appendTo('#abOverlayVideo');
        }

        //$(".abOverlayBox").css({ width: 600, height: 470 });
        $(".abOverlayBox").css({ width: 605, height: 470 });
        window.top.$("#iframeVideo").css("visibility", "visible");
        window.top.$("#iframeVideo").attr("src", src); //cannot just remove the iframe here because facebook throws js errors! so as a work around change the url then on load remove the iframe.
        showOverlayBox();
        $('.abOverlayBgCover').css({ opacity: 0 }).animate({ opacity: 0.6, backgroundColor: '#000' });
        // dont follow the link : so return false.
        //HelpController.InstrumentLink("Topic:" + q.ContentID);    //OV2    
        //if ($('#summaryEntityTab').hasClass('ui-tabs')) {
        //    $('#summaryEntityTab').toggleClass('ui-tabs', 'ui-tabs-overlay');
        //    $('.advertiser-tab-header').toggleClass('ui-tabs', 'ui-tabs-overlay');
        //}
        var ua = navigator.userAgent.toLowerCase();
        var isChrome = ua.indexOf('chrome') > -1;
        var isSafari = ua.indexOf('safari') > -1;
        if (isChrome || isSafari) {
            $("#abOverlayVideo").css("margin-top", "10px");
        };
        //$('#railhelp_show').css('opacity', '0.4');
        //$('#railhelp_show *').attr('disabled', 'true');

        $('span#abOverlayClose').focus();
        return false;
    };

    var doOverlayClose = function () {

        if ($("#railHelpInputs").attr("query") == '_popup_video_') window.close();
        //set status to closed
        isOpen = false;
        $('.abOverlayBox').css('display', 'none');
        // now animate the background to fade out to opacity 0
        // and then hide it after the animation is complete.
        $('.abOverlayBgCover').animate({ opacity: 0 }, null, null, function () { $(this).hide(); });

        window.top.$("#iframeVideo").css("visibility", "hidden");
        window.top.$("#iframeVideo").attr("src", ""); //cannot just remove the iframe here because facebook throws js errors! so as a work around change the url then on load remove the iframe.
        //window.top.location.hash = "";
        //if ($('#summaryEntityTab').hasClass('ui-tabs-overlay')) {
        //    $('#summaryEntityTab').toggleClass('ui-tabs-overlay', 'ui-tabs');
        //    $('.advertiser-tab-header').toggleClass('ui-tabs-overlay', 'ui-tabs');
        //}
        //$('#railhelp_show').css('opacity', '1');
        //$('#railhelp_show *').removeAttr('disabled');
        var elem = $('span#abOverlayClose').data("element");
        $(elem).focus();
        $('span#abOverlayClose').data("element", "");
    };
    var getHeight = function () {
        var h = 325;
        return h;
    };
    var getWidth = function () {
        var w = 550;
        return w;
    };

    var showVideo = function (event) {
        //read the uuid from ids
        $('span#abOverlayClose').data("element", event.target);
        var uuid = $(event.target).attr("videoId");
        var opid = $(event.target).attr("op_videoId");
        var pos = $(event.target).attr("pos");
        var height = getHeight();
        var width = getWidth();


        if (uuid === undefined) {
            //Go one level up to get videoId from anchor tag  
            uuid = $(event.target).parent().attr('videoId');
            opid = $(event.target).parent().attr("op_videoId");
        }

        var nocache = '&random=' + (new Date()).getTime() + Math.floor(Math.random() * 1000000);
        if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//"
                + window.location.hostname
                + (window.location.port ? ':' + window.location.port : '');
        }

        var src = apex_glb.EndPoint + '/resources/neutral/ApexOnePlayerVideoHandler.htm?uuid=' + uuid + '&opid=' + opid + '&prd=' + apex_glb.Project + '&mkt=' + apex_glb.Language + '&w=' + width + '&h=' + height + nocache;

        if (opid == null || opid == "" || opid == "OnePlayerIDValue") {
            src = apex_glb.EndPoint + '/resources/neutral/ApexYoutubeVideoHandler.htm?uuid=' + uuid + '&w=' + width + '&h=' + height + nocache;
        }
        //var src = apex_glb.EndPoint + '/resources/neutral/ApexYoutubeVideoHandler.htm?uuid=' + uuid + '&w=' + width + '&h=' + height + nocache;
        doOverlayOpen(src, event.target);
        ApexEmbedLogger.Instrument('help', apex_glb.Project, apex_glb.Language, uuid, '', '', 'Video', '');
        return false;
    };

    return {
        DoOverlayOpen: doOverlayOpen,
        DoOverlayClose: doOverlayClose,
        ShowOverlay: function () {
            showOverlayBox();
        },
        ShowVideo: function (event) {
            return showVideo(event);
        },
        Init: function () {
            buildVideoOverlayHtml();

            // if window is resized then reposition the overlay box
            $(window).bind('resize', showOverlayBox);

            $('.abLaunchVideo').unbind('click');
            $('.abLaunchVideo').bind('click', function (event) {
                return showVideo(event);
            });

            $('div.apexContentTile span.abLaunchVideo, #abOverlayClose').unbind('keypress');
            $('div.apexContentTile span.abLaunchVideo, #abOverlayClose').bind('keypress', function (event) {
                if (event.which === 13) {
                    $(event.target).trigger('click');
                }
            });

            $("a#abOverlayClose, span#abOverlayClose").keydown(function (e) {
                //if (e.preventDefault) { e.preventDefault(); }
                var keycode = (e.keyCode ? e.keyCode : (e.which ? e.which : e.charCode));
                if ((keycode === 13) || (keycode === 27)) { // keycode for enter key or ESC key
                    if (e.preventDefault) { e.preventDefault(); }
                    if (e.stopPropagation) { e.stopPropagation(); }
                    $(e.target).trigger('click');
                }
            });

            $('a#abOverlayClose, span#abOverlayClose').unbind('click');
            $('a#abOverlayClose, span#abOverlayClose').bind('click', function (event) {
                ApexVideoHandler.DoOverlayClose();
            });
            $('#abOverlayClose').unbind('click');
            $('#abOverlayClose').bind('click', function (event) {
                ApexVideoHandler.DoOverlayClose();
            });

        }
    };

}();

/*-----------------------------------------------------------
//  Name: ApexCookieHandler
//  Description: ApexCookieHandler
//
// -------------------------------------------------------*/
ApexCookieHandler = function () {
    // Private
    //    var htmlDecode = function (value) {
    //        return $('<div/>').html(value).text();
    //    }

    //    var htmlEncode = function (value) {
    //        return $('<div/>').text(value).html();
    //    }
    return {

        // getCokkie
        getCookie: function (name) {
            if ((name == undefined) || (name == null) || (name == '')) return null;
            name = name.toLowerCase();
            //try{
            //    return window.localStorage.getItem(name);
            //}
            //catch(e){}
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },

        /*
        Set cookie with expiration .  Path, Domain, Secure are all optional
        name = cookie name
        value = value of cookie
        expires = no. of days
        path = path name
        domain = domain name
        */
        setCookie: function (name, value, days) {
            var expires;
            if ((name == undefined) || (name == null) || (name == '')) return;
            name = name.toLowerCase();
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            }
            else expires = "";
            var dstr = ";domain=.ads.microsoft.com; path=/";
            if (document.domain.indexOf('ads-int') > 0) {
                dstr = ";domain=.ads-int.microsoft.com; path=/";
            }
            //document.domain = ".bingads.microsoft.com";
            //document.cookie = name + "=" + value + expires + ";domain=.bingads.microsoft.com; path=/";
            document.cookie = name + "=" + value + expires + dstr;
            //window.localStorage.setItem(name, value);
        },

        // this deletes the cookie when called
        removeCookie: function (name) {
            if ((name == undefined) || (name == null) || (name == '')) return;
            name = name.toLowerCase();
            //try {
            //    return window.localStorage.removeItem(name);
            //}
            //catch (e) { }
            if (ApexCookieHandler.getCookie(name)) {
                ApexCookieHandler.setCookie(name, "", -1);
            }
        }
    };

}();

/*-----------------------------------------------------------
//  Name: ApexEmbedLogger
//  Description: ApexEmbedLogger -  Logging into Aria 
//  eg.: ApexEmbedLogger.Instrument('help', project, apex_glb.HelpMarket, query, '', '', 'page', viewId);
//       ApexEmbedLogger.Instrument('help', project, apex_glb.HelpMarket, query, 'hlp_ba_sample.xml', '10', 'search', viewId);
// -------------------------------------------------------*/
ApexEmbedLogger = function () {
    var logAriaEvent = function (source, project, language, query, filename, row, logType, view) {
        //Log an event using fluent syntax for page view.
        //if (apex_glb.Authorize == true) return;
        query = (query == null || query === "") ? 'NONE' : query;
        filename = (filename == null || filename === "") ? 'NONE' : filename;
        row = (row == null || row === "") ? 'NONE' : row;
        logType = (logType == null || logType === "") ? 'NONE' : logType;
        view = (view == null || view === "") ? 'NONE' : view;
        var url = apex_glb.EndPoint + "/api/logaria";
        var referer = window.location.href;

        var input = {
            'name': 'help',
            'source': source,
            'project': project,
            'language': language,
            'filename': filename,
            'row': row,
            'query': query,
            'logtype': logType,
            'view': view,
            referer: referer
        };

        //self.setNavItem(nav);
        $.ajax({
            url: url,
            type: "GET",
            data: input,
            cache: false
        }
        );
    };
    var sendFeedback = function (source, project, language, query, answer, answerText, filename, view) {
        //Log an event using fluent syntax for page view.
        //if (apex_glb.Authorize == true) return;
        query = (query == null || query === "") ? 'NONE' : query;
        answer = (answer == null || answer === "") ? 'NONE' : answer;
        answerText = (answerText == null || answerText === "") ? 'NONE' : answerText;
        filename = (filename == null || filename === "") ? 'NONE' : filename;
        logType = (logType == null || logType === "") ? 'NONE' : logType;
        view = (view == null || view === "") ? 'NONE' : view;
        var url = apex_glb.EndPoint + "/api/logaria/feedback";

        var input = {
            'source': source,
            'project': project,
            'language': language,
            'answer': answer,
            'answerText': answerText,
            'filename': filename,
            'query': query,
            'view': view
        };

        //self.setNavItem(nav);
        $.ajax({
            url: url,
            type: "GET",
            data: input,
            cache: false
        }
        );
    };
    return {
        Instrument: logAriaEvent,
        Feedback: sendFeedback
    };
}();


/*-----------------------------------------------------------
//  Name: RailHelpController
//  Description: RailHelpController 
//
// -------------------------------------------------------*/
RailHelpController = function () {
    var myself = this;

    var currentQuery = "";
    var currentRailContent = null;
    var originalRailContent = null;
    var currentRailIndex = 0;
    var activeJSQuery = null;
    var prevView = "";
    var currentView = "";
    var currentQueries = "";
    var isNewQuery = false;
    var dropDownBusy = false;
    var isDebugMode = false;
    var isDraggable = false;
    var railHtmlRoot = "#railhtml";

    var hideVideoTab = false;
    var enableCopy = true;
    var showRating = true;
    var isSearchFocused = false;
    var isResizeBusy = false;
    var isRefreshed = false;
    var isChromePinned = true;
    var barIcon = "";
    var hoverOnDelay = 0;
    var instrumentPage = false;
    var contentHistory = [];

    var enableRTLLanguage = function () {
        var rtl = window.ab_glb.HelpMarket.toLowerCase().substring(0, 3);
        var idx = $.inArray(rtl, ["ar-", "he-", "fa-"]);
        window.ab_glb.IsBIDIMarket = idx > -1;
    };


    var addContentForBackButton = function (content, related) {
        var data = {
            'term': $('input#searchquery').val(),
            'head': $('#apex_content_title').html(),
            'query': apex_glb.CurrentQuery,
            'content': content,
            'related': related,
            'title': $(railHtmlRoot).attr('aria-label')
        }

        contentHistory.push(data);
        if (contentHistory.length > 1) {
            $('#apexHelpContainer .apex_search_area .back_button').removeClass('disabled').addClass('active');
            $('#apexHelpContainer .apex_search_area .back_button').attr('tabindex', '0');
            $('#apexHelpContainer .apex_search_area .back_button').attr('aria-disabled', 'false');

            if (!$("#apexHelpContainer #apex_support_area").is(":visible") && !$("#apexHelpContainer #apexSupportOption").is(":visible")) {
                $("#apex_platform_chrome #apex_dropdown_moreoptions").unbind('keydown');
                $("#apex_platform_chrome #apex_back_button").unbind('keydown');
                var lastElementNoSupport = findLastVisibleElement($('#apexHelpContainer'));
                var firstElem = $("#apex_platform_chrome #apex_back_button").hasClass("disabled") || !$("#apex_platform_chrome #apex_back_button").is(":visible") ? $("#apex_platform_chrome #apex_dropdown_moreoptions") : $("#apex_platform_chrome #apex_back_button");
                var lastElem = $(lastElementNoSupport);
                ApexPlatform.ApexTrapFocus(firstElem, lastElem);
            }
        }
    };

    var getContentForBackButton = function () {

        if (contentHistory.length >= 2) {
            var content = contentHistory.pop();
            content = contentHistory.pop();
            contentHistory.push(content);

            $('#apexHelpContainer ' + window.ab_glb.ContentRootElement).html('');
            $('#apexHelpContainer ' + window.ab_glb.ContentRootElement).html(content.content);
            var apexCls = apex_glb.Project.toLowerCase();
            $('#apexHelpContainer ' + window.ab_glb.ContentRootElement + ' #cntnt').removeClass(apexCls).addClass(apexCls);
            $('#apexHelpContainer ' + window.ab_glb.ContentRootElement + ' #related_articles').html(content.related);
            $('#apexHelpContainer input#searchquery').val(content.term);
            $('#apexHelpContainer input#searchquery').focus();
            $(railHtmlRoot).attr('aria-label', content.title);
            if (content.head == '') {
                $('#apex_content_title').hide();
            }
            else {
                $('#apex_content_title').html(content.head);
                $('#apex_content_title').show();
            }
            if (contentHistory.length <= 1) {
                $('#apexHelpContainer .apex_search_area .back_button').removeClass('active').addClass('disabled');
                $('#apexHelpContainer .apex_search_area .back_button').attr('tabindex', '-1');
                $('#apexHelpContainer .apex_search_area .back_button').attr('aria-disabled', 'true');
            }
            if ($('#apexHelpContainer .apex_content_area ' + window.ab_glb.ContentRootElement).length > 0) {
                setScrollBar($('#apexHelpContainer .apex_content_area ' + window.ab_glb.ContentRootElement)[0].scrollHeight);
            }
            apex_glb.CurrentQuery = !content.query ? "" : content.query;
            updateUrlPaths();

            //var sessionQuery = ApexCookieHandler.getCookie($('#railHelpInputs').attr('ApexSessionId'));
            //if (sessionQuery != null) {
            //    var qry = [];
            //    qry = sessionQuery.split('~');
            //    query = qry[0];
            //    $('#apexHelpContainer #railContent #cntnt').scrollTop(qry[1]);
            //    $.each(qry, function (key, value) { if (key > 1) $('#apexHelpContainer #railContent #' + value).trigger('click') });
            //}
            ApexCookieHandler.setCookie($('#railHelpInputs').attr('ApexSessionId'), content.query);
            var viewId = $('[RailViewID]')[0] == undefined ? RailHelpController.GetViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
            ApexEmbedLogger.Instrument('help', apex_glb.Project, apex_glb.Language, content.query, '', '', 'back', viewId);

            if (!$("#apexHelpContainer #apex_support_area").is(":visible") && !$("#apexHelpContainer #apexSupportOption").is(":visible")) {
                $("#apex_platform_chrome #apex_dropdown_moreoptions").unbind('keydown');
                $("#apex_platform_chrome #apex_back_button").unbind('keydown');
                var lastElementNoSupport = findLastVisibleElement($('#apexHelpContainer'));
                var firstElem = $("#apex_platform_chrome #apex_back_button").hasClass("disabled") || !$("#apex_platform_chrome #apex_back_button").is(":visible") ? $("#apex_platform_chrome #apex_dropdown_moreoptions") : $("#apex_platform_chrome #apex_back_button");
                var lastElem = $(lastElementNoSupport);
                ApexPlatform.ApexTrapFocus(firstElem, lastElem);
            }

            loadOnDemandContent();
            $.fn.ApexDropDown();
        }
    };

    var toggleHoverClass = function (e, removeClass, addClass) {
        e.removeClass(removeClass);
        e.addClass(addClass);
    };


    var getSearchTerm = function () {
        var value = $("#apexHelpContainer #searchquery").val();
        if ((value == apex_glb.LocStrings.Search) || value.length == 0) { return null; }

        var query = getEncodedQuery(value);
        return value;
    };

    var getEncodedQuery = function (query) {
        var userQuery = (query != null && query.length > 0) ? query : "";
        try { userQuery = encodeURIComponent(userQuery); }
        catch (ex) { userQuery = escape(userQuery); }
        return userQuery;
    };

    var helpSearch_Click = function (project) {
        if (isSearchFocused == false)
            return;

        var value = getSearchTerm();
        if (value == null) return false;
        var viewId = $('[RailViewID]')[0] == undefined ? RailHelpController.GetViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
        ApexEmbedLogger.Instrument('help', apex_glb.Project, apex_glb.Language, value, '', '', 'search', viewId);
        return getABContent(value, "s");
    };

    var helpSearch_Focus = function (oInput) {
        isSearchFocused = true;
        var val = oInput.val();
        if (val == apex_glb.LocStrings.Search) {
            oInput.val(''); //remove the default text if it is present
            oInput.removeClass("watermark");
        }
        oInput.select();
    };

    var helpSearch_Blur = function (oInput) {
        var val = oInput.val();
        if (val == null || val.length == 0) oInput.val(apex_glb.LocStrings.Search);
    };

    var findLastVisibleElement = function (elem) {
        var focusable = document.getElementById(elem.attr('id')).querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        var i;
        var lastElement = null;
        for (i = focusable.length - 1; i >= 0; i--) {
            var el = focusable[i];
            var found = !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
            if (found) {
                lastElement = el;
                if ($(lastElement).attr("id") == undefined) {
                    $(lastElement).attr("id", "last-help-element");
                }
                break;
            }
        }

        return lastElement;
    }

    // Tab to search suggestions list from search input
    var tabToSuggestions = function () {
        var searchInput = $(".apex_search_area input#searchquery");
        var suggestionList = $("#apex-suggestion-box");

        searchInput.keydown(function (e) {
            if (searchInput.val() != "" && suggestionList.is(':visible')) {
                if (e.which === 9) {
                    if (e.preventDefault) { e.preventDefault(); }
                    $(".apex_search_area input#searchquery").blur();
                    suggestionList.css('display', 'block');
                    var suggestionAmmount = $("#apex-suggestion-box-list li").length + ' suggestions found, use tab to review';
                    $("#announce-suggestions").html(suggestionAmmount);
                    $("#apex-suggestion-box-list li:first a").focus();
                };
            }
        });
    }

    var bindChromeSearchClickEvents = function () {
        if ($(".apex_search_area input#searchquery") != undefined && $(".apex_search_area input#searchsubmit").length > 0) {
            $(".apex_search_area input#searchquery").keydown(function (e) {
                var keycode = (e.keyCode ? e.keyCode : (e.which ? e.which : e.charCode));
                if (keycode === 13) { // keycode for enter key
                    if (e.preventDefault) { e.preventDefault(); }
                    helpSearch_Click(apex_glb.Project);
                }
            });
            $(".apex_search_area input#searchsubmit").click(function (e) {
                if (e.preventDefault) { e.preventDefault(); }
                helpSearch_Click(apex_glb.Project);
            });
            $(".apex_search_area input#searchquery").blur(function (e) {
                helpSearch_Blur($(this));
            });

            $(".apex_search_area input#searchquery").focus(function (e) {
                helpSearch_Focus($(this));
                tabToSuggestions();
            });

            $(".apex_search_area input#searchsubmit").focus(function (e) {
                isSearchFocused = true;
            });

        }
    };

    var getContentVideo = function (e) {

        ApexVideoHandler.ShowVideo(e);

    };

    var getContentArticle = function (e) {
        var topicId = '';
        var fileName = '';
        var row = '0';
        if ($(e.target).hasClass('highlight')) {
            topicId = $(e.target).parent().attr('secretkey');
            fileName = $(e.target).parent().attr('topic');
            row = $(e.target).parent().attr('row');
        } else {
            topicId = $(e.target).attr('secretkey');
            fileName = $(e.target).attr('topic');
            row = $(e.target).attr('row');
        }
        var logType = 'landing';
        if ($(e).parentsUntil('.hSearchRow.Search').length == 1) {
            logType = 'result';
        }
        var viewId = $('[RailViewID]')[0] == undefined ? RailHelpController.GetViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
        ApexEmbedLogger.Instrument('help', apex_glb.Project, apex_glb.Language, topicId, fileName, row, logType, viewId);
        return getABContent(topicId);
    };

    var getContentTour = function (e) {
        //TODO: TO BE IMPLEMENTED
        try {
            if (typeof WalkMeAPI != 'undefined' && typeof WalkMeAPI.startWalkthruById == 'function') {
                walkmeId = parseInt($(e.target).attr('wid'));
                WalkMeAPI.startWalkthruById(walkmeId);
            }
        }
        catch (e) { };
    };

    var bindContentClickEvents = function () {

        $("#apexHelpContainer").off('click', ".apex_content_area .hSearchRow.Tour .SearchTitle span[role='link']");
        $("#apexHelpContainer").on('click', ".apex_content_area .hSearchRow.Tour .SearchTitle span[role='link']", ".apex_content_area .hSearchRow.Tour .SearchTitle span[role='link']", function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            getContentTour(e);
        })
        $("#apexHelpContainer").off('click', ".apex_content_area .hSearchRow.Video .SearchTitle span[role='link'], .apex_content_area .abLaunchVideo");
        $("#apexHelpContainer").on('click', ".apex_content_area .hSearchRow.Video .SearchTitle span[role='link'], .apex_content_area .abLaunchVideo", function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            getContentVideo(e);
        })

        $("#apex-suggestion-box").off("click", '#apex-suggestion-box-list li span[videoid], #apex-suggestion-box-list li a[videoid]');
        $("#apex-suggestion-box").on("click", '#apex-suggestion-box-list li span[videoid], #apex-suggestion-box-list li a[videoid]', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            getContentVideo(e);
        });

        $("#apexHelpContainer").off('keypress', ".apex_content_area .hSearchRow.Video .SearchTitle span[role='link'], .apex_content_area .abLaunchVideo, #abOverlayClose");
        $("#apexHelpContainer").on('keypress', ".apex_content_area .hSearchRow.Video .SearchTitle span[role='link'], .apex_content_area .abLaunchVideo, #abOverlayClose", function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            if (event.which === 13) {
                $(e.target).trigger('click');
            }
        });


        $("#apexHelpContainer").off('click', ".apex_content_area .hSearchRow.Articles .SearchTitle a[role='link']");
        $("#apexHelpContainer").on('click', ".apex_content_area .hSearchRow.Articles .SearchTitle a[role='link']", function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            getContentArticle(e);
        })
        $("#apex-suggestion-box").off('click', 'ul#apex-suggestion-box-list li a');
        $("#apex-suggestion-box").on('click', 'ul#apex-suggestion-box-list li a', function (e) {

            if (e.preventDefault) { e.preventDefault(); };
            if ($(e.target).attr('VideoId') !== undefined) { return false; }

            getContentArticle(e);
        })

        $("#apexHelpContainer").off('click', window.ab_glb.ContentRootElement + ' #cntnt a.LINK');
        $("#apexHelpContainer").on('click', window.ab_glb.ContentRootElement + ' #cntnt a.LINK', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            if ($(e.target).attr('targetId') !== undefined) {
                var target = window.ab_glb.ContentRootElement + ' #cntnt ' + $(e.target).attr('targetId');
                //$(window.ab_glb.ContentRootElement + ' #cntnt').scrollTop($(window.ab_glb.ContentRootElement + " #cntnt").scrollTop() + $(target).position().top);
                $('#railContent').scrollTop($('#railContent').scrollTop() + $(target).position().top);
            }
        })

        $("#apexHelpContainer").off('click', window.ab_glb.ContentRootElement + ' #cntnt #spinOffWindow');
        $("#apexHelpContainer").on('click', window.ab_glb.ContentRootElement + ' #cntnt #spinOffWindow', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            spinOffNewWindow(e);
        })
    };

    jQuery.fn.hasVScroll = function () {
        return this.get(0) ? this.get(0).scrollHeight > this.innerHeight() : false;
    };


    var setScrollBar = function (height) {
        //var scroll_height = height-50;
        //$("#railContent").height(scroll_height);
        //$("#railContent").css('height', '"' + scroll_height + 'px"');
        //var offset = $('#apexHelpContainer #railContent').offset();
        // var remaining_height = parseInt($(window).height() - offset.top - 50);
        // $('#apexHelpContainer #railContent').height(remaining_height);
        //try {
        // $('#apexHelpContainer .apex_content_area #railContent').css('overflow-y', 'auto !important');
        //$('#railContent').perfectScrollbar('update');
        //}
        //catch (e) { };
        //if ($("#apexHelpContainer #railContent").hasVScroll()) {
        //}
        $('#apexHelpContainer  #railContent').scrollTop(0);
    };

    var opener = null;

    var linkHandler = function (e) {
        opener = this;
        if (window.apex_glb && typeof window.apex_glb.onRailViewOpen === 'function') {
            window.apex_glb.onRailViewOpen(opener);
        }

        if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
        if (e.preventDefault) { e.preventDefault(); };
        try {
            if ($('.apex_platform_chrome').length <= 0) {
                ApexPlatform.Init();
            }
        }
        catch (ex) { };


        //if ($(e.target).attr('href_new') && $(e.target).attr('query')) {
        var query = apex_glb.Query.toLowerCase();
        if ($(e.target).attr('query')) {
            query = $(e.target).attr('query');
        }
        else if ($(e.target).parent().attr('query')) {
            query = $(e.target).parent().attr('query');
        }
        var viewId = $('[RailViewID]')[0] == undefined ? RailHelpController.GetViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
        ApexEmbedLogger.Instrument('help', apex_glb.Project, apex_glb.Language, query, '', '', 'page', viewId);

        if (query != apex_glb.CurrentQuery.toLowerCase()) {
            getABContent(query, null, 0);
        }
        else {
            showHelp(true);
            ApexCookieHandler.setCookie($('#railHelpInputs').attr('ApexSessionId'), apex_glb.CurrentQuery);
        }
        if ($('#apexHelpContainer .apex_content_area ' + window.ab_glb.ContentRootElement).length > 0) {
            setScrollBar($('#apexHelpContainer .apex_content_area ' + window.ab_glb.ContentRootElement)[0].scrollHeight);
        }
    };

    var spinOffNewWindow = function (e) {
        if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
        if (e.preventDefault) { e.preventDefault(); };
        var url = $(e.target).parent().attr('url');
        if (url == undefined || url == null) url = $(e.target).attr('url');
        //var win = window.open(url, '_apexHelpWindow');
        //if (win) win.focus();
        const urlObj = new URL(url);
        const curSearch = window.location.search;
        urlObj.search = curSearch;
        url = urlObj.toString();

        if (window.apexHelpSpinOffWindow) window.apexHelpSpinOffWindow.close();
        const child = window.open(url, "_apexHelpWindow");
        window.apexHelpSpinOffWindow = child;
        if (child) {
            child.focus();
            //Scrope script in child windows
            child.frames.eval('setInterval(function () {if (!window.opener.apexHelpSpinOffWindow) window.opener.apexHelpSpinOffWindow = window; }, 500);');
        }
    };

    var copyTopicHandler = function (e) {
        var url = $(e.target).parent().attr('url');
        if (url == undefined || url == null) url = $(e.target).attr('url');
        url = url.toLowerCase();
        if (window.clipboardData) // IE
        {
            window.clipboardData.setData("Text", url);
            $(".apex_search_area input#searchquery").focus();
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = url;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            } catch (ex) {

                return false;
            } finally {
                document.body.removeChild(textarea);
                $(".apex_search_area input#searchquery").focus();
            }
        }
        $(".apex_search_area input#searchquery").focus();
        //if ($.browser.msie) {
        //    try {
        //        if (window.clipboardData) // IE
        //        {
        //            window.clipboardData.setData("Text", url);
        //        }
        //    }
        //    catch (e)
        //    { }
        //}
        //else {
        //    var body_message = url;
        //    var mailto_link = 'mailto:?body=' + encodeURIComponent(body_message);
        //    window.location.replace(mailto_link, 'emailWindow');
        //}
        //return false;
    };

    var fwLinkHandler = function (e) {
        var url = $(e.target).attr('href');
        if (url === undefined || url == '#') return false;
        //var win = window.open(url, '_apexHelpWindow');
        //if (win) win.focus();
        if (window.apexHelpSpinOffWindow) window.apexHelpSpinOffWindow.close();
        const child = window.open(url, "_apexHelpWindow");
        window.apexHelpSpinOffWindow = child;
        if (child) {
            child.focus();
            //Scrope script in child windows
            try {
                if (child.frames && child.frames.length > 0) {
                    child.frames.eval('setInterval(function () {if (!window.opener.apexHelpSpinOffWindow) window.opener.apexHelpSpinOffWindow = window; }, 500);');
                }
            }
            catch (e) { }
        }
    };


    var bindPlatformEvents = function () {
        $(document).off('click', '.HelpTopic, .HelpTopic span, .HelpTopic div, .apexHelpLink, .help-topic-link');
        //$(document).on('click', '.HelpTopic, .HelpTopic span, .apexHelpLink', linkHandler);
        //document.querySelector('.HelpTopic, .HelpTopic span, .apexHelpLink').addEventListener('click', function (e) {
        //    linkHandler.call(e.target, e);
        //}, true);

        document.addEventListener('click', function (e) {
            for (var target = e.target; target && target != this; target = target.parent) {
                try {
                    if (typeof target.matches == "function") {
                        if (target.matches('.HelpTopic, .HelpTopic span, .HelpTopic div, .apexHelpLink, .help-topic-link')) {
                            linkHandler.call(target, e);
                        }
                    }
                }
                catch (e) { };
            }

        }, true);

        $(window.ab_glb.ContentRootElement).off('click', window.ab_glb.ContentRootElement + " a[href*='fwlink'], " + window.ab_glb.ContentRootElement + " a:not([href*='/#apex/'])");
        $(window.ab_glb.ContentRootElement).on('click', window.ab_glb.ContentRootElement + " a[href*='fwlink'], " + window.ab_glb.ContentRootElement + " a:not([href*='/#apex/'])", fwLinkHandler);

        //$("#railContent a[href='#']").die('click');
        //$("#railContent a[href='#']").live('click', function () { return false; });
    };

    //check if exist and is visible
    var isVisible = function (element) {
        if (element.length > 0 && element.css('visibility') !== 'hidden' && element.css('display') !== 'none') {
            return true;
        } else {
            return false;
        }
    };

    var keydownEscHandler = function (e) {
        //if (e.preventDefault) { e.preventDefault(); }
        //if (e.stopPropagation) { e.stopPropagation(); }
        if (e.which === 27) {
            if (document.activeElement.id == "homeImage" || document.activeElement.id == "newToBingAds" || document.activeElement.id == "videoGallery" || document.activeElement.id == "spinOffWindow" || document.activeElement.id == "copyTopic") {
                $('.dropdown-content').hide();
                $("#apexHelpContainer span.dropdown_moreoptions").attr("aria-expanded", "false");
                $('#apexHelpContainer span.dropdown_moreoptions').focus();
            }
            else if ($('#_helpcontainer').is(':visible')) {
                if (e.stopPropagation) { e.stopPropagation(); };
                $('#_helpPopupCloseLink').click();
            }
            else if ($('#apex-suggestion-box').css('display') !== 'none') {
                $("#apex-suggestion-box").css("display", "none");
                $(".apex_search_area input#searchquery").focus();
                $(".apex_search_area input#searchquery").attr("aria-activedescendant", "");
            }
            else if ($('#abOverlayBox').is(':visible')) {
                $('span#abOverlayClose').click();
            }
            else if ($('#apexHelpContainer .apex_header div.dropdown-content').is(':visible')) {
                $('#apexHelpContainer span.dropdown_moreoptions').click();
                $('#apexHelpContainer span.dropdown_moreoptions').focus();
            }
            else if ($('#apex_platform_chrome').is(':visible')) {
                $("#apexHelpContainer .apex_header .close_button").click();
            }

        }

        if (e.which === 13) {
            if (document.activeElement.id == "support-callme-text") {
                if (e.stopPropagation) { e.stopPropagation() };
                $('#apexSupportOption li.nav-support-options-callme #support-callme-text').trigger('click');
            }
        }
    }

    var dropdownHideHandler = function (e) {
        if (dropDownBusy) { dropDownBusy = false; return true; }
        //if (e.preventDefault) { e.preventDefault(); };
        var elem = $('#apexHelpContainer .apex_header div.dropdown-content');
        if (isVisible(elem)) {
            elem.hide();
            $("#apexHelpContainer .apex_header span.dropdown_moreoptions").attr("aria-expanded", "false");
        };
    };

    var bindChromeClickEvents = function () {

        bindChromeSearchClickEvents();

        $("#apexHelpContainer .apex_search_area span.back_button").unbind('click');
        $("#apexHelpContainer .apex_search_area span.back_button").bind('click', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            getContentForBackButton();
        });
        $("#apexHelpContainer .apex_header span.dropdown_moreoptions").unbind('click');
        $("#apexHelpContainer .apex_header span.dropdown_moreoptions").bind('click', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            $('input#searchquery').blur();
            $('#apexHelpContainer .apex_header div.dropdown-content').toggle();
            dropDownBusy = true;
            if ($('#apexHelpContainer .apex_header div.dropdown-content').is(":visible") == true) {
                $("#apexHelpContainer .apex_header span.dropdown_moreoptions").attr("aria-expanded", "true");
                $("#apexHelpContainer .apex_header span.dropdown_moreoptions a").first().focus();
                var firstElem = $("#apexHelpContainer .apex_header span.dropdown_moreoptions a:first");
                var lastElem = $("#apexHelpContainer .apex_header span.dropdown_moreoptions a:visible:last");
                ApexPlatform.ApexTrapFocus(firstElem, lastElem);
            }
            else {
                $("#apexHelpContainer .apex_header span.dropdown_moreoptions").attr("aria-expanded", "false");
            }
        });

        $('#apexHelpContainer .apex_header span.dropdown_moreoptions').unbind('keypress');
        $('#apexHelpContainer .apex_header span.dropdown_moreoptions').bind('keypress', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            if (e.which === 13) {
                $('#apexHelpContainer .apex_header div.dropdown-content').toggle();
                dropDownBusy = true;
                var firstElem = $("#apexHelpContainer .apex_header span.dropdown_moreoptions a:first");
                var lastElem = $("#apexHelpContainer .apex_header span.dropdown_moreoptions a:visible:last");
                ApexPlatform.ApexTrapFocus(firstElem, lastElem);
                if ($('#apexHelpContainer .apex_header div.dropdown-content').is(":visible") == true) {
                    $("#apexHelpContainer .apex_header span.dropdown_moreoptions").attr("aria-expanded", "true");
                    $("#apexHelpContainer .apex_header span.dropdown_moreoptions a").first().focus();
                }
                else {
                    $("#apexHelpContainer .apex_header span.dropdown_moreoptions").attr("aria-expanded", "false");
                }
            }
        });

        $("#apexHelpContainer .apex_header span.dropdown_moreoptions").unbind('keyup');
        $("#apexHelpContainer .apex_header span.dropdown_moreoptions").bind('keyup', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            if (e.stopPropagation) { e.stopPropagation() };
            if ($("#apexHelpContainer .apex_header span.dropdown_moreoptions .dropdown-content").is(":visible") == true) {

                if (e.which === 27) {
                    $('#apexHelpContainer .apex_header div.dropdown-content').toggle();
                    $("#apexHelpContainer .apex_header span.dropdown_moreoptions").attr("aria-expanded", "false");
                    $(this).focus();
                }
            }
        });

        $("#apexHelpContainer").unbind('click', dropdownHideHandler);
        $("#apexHelpContainer").bind('click', dropdownHideHandler);

        var onClose = function() {
            if (opener != null) {
                $(opener).focus();
            }

            if (window.apex_glb && typeof window.apex_glb.onRailViewClose === 'function') {
                window.apex_glb.onRailViewClose(opener);
            }

            if ($("#apex-suggestion-box").is(":visible") == true) {
                $("#apex-suggestion-box").css("display", "none");
                $("#announce-suggestions").html("");
                $(".apex_search_area input#searchquery").attr("aria-activedescendant", "");
            }
        }

        var closeHelpView = function() {
            window.ab_glb.HelpOpened = false;
            $('#apexHelpContainer').attr('style', null);
            showHelp(false);
            onClose();
            ApexCookieHandler.removeCookie($('#railHelpInputs').attr('ApexSessionId'));
            var viewId = $('[RailViewID]')[0] == undefined ? RailHelpController.GetViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
            ApexEmbedLogger.Instrument('help', apex_glb.Project, apex_glb.Language, apex_glb.CurrentQuery, '', '', 'close', viewId);
        }

        $("#apexHelpContainer .apex_header span.close_button").unbind('click');
        $("#apexHelpContainer .apex_header span.close_button").bind('click', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            closeHelpView();
        });

        window.apex_glb.closeHelpView = closeHelpView;

        $("#apexHelpContainer .apex_header span.close_button, #apexHelpContainer .apex_search_area span.back_button, #apexHelpContainer .apex_search_area div.dropdown-content a").unbind('keypress');
        $("#apexHelpContainer .apex_header span.close_button, #apexHelpContainer .apex_search_area span.back_button, #apexHelpContainer .apex_search_area div.dropdown-content a").bind('keypress', function (event) {
            if (event.preventDefault) { event.preventDefault(); };
            if (event.which === 13) {
                $(event.target).trigger('click');
            }
        });

        $("#apexHelpContainer .apex_header span.dropdown_moreoptions a").off('keypress');
        $("#apexHelpContainer .apex_header span.dropdown_moreoptions a").on('keypress', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            if (e.which === 13) {
                $(e.target).trigger('click');
            }
        });

        $('#apexHelpContainer #spinOffWindow').off('click');
        $('#apexHelpContainer #spinOffWindow').on('click', spinOffNewWindow);

        $('#apexHelpContainer #copyTopic').unbind('click');
        $('#apexHelpContainer #copyTopic').bind('click', copyTopicHandler);

        $("#apexHelpContainer .apex_support_area span.support_label, #apexHelpContainer .apex_support_area .support img").unbind('click');
        $("#apexHelpContainer .apex_support_area span.support_label, #apexHelpContainer .apex_support_area .support img").bind('click', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            var viewId = $('[RailViewID]')[0] == undefined ? RailHelpController.GetViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
            ApexEmbedLogger.Instrument('help', apex_glb.Project, apex_glb.Language, apex_glb.CurrentQuery, '', '', 'support', viewId);
            var url = $('#apexHelpContainer #apex_support_area .support').attr('url');
            if (url != '') {
                window.open(url, '_apexSupport');
            }
        })

        $("#apexHelpContainer .apex_support_area span.support_label, #apexHelpContainer .apex_support_area .support img").unbind('keypress');
        $("#apexHelpContainer .apex_support_area span.support_label, #apexHelpContainer .apex_support_area .support img").bind('keypress', function (e) {
            if (e.preventDefault) { e.preventDefault(); };
            if (e.which === 13) {
                $(e.target).trigger('click');
            }
        })

        $(document).off('keydown', keydownEscHandler);
        //$(document).on('keydown', keydownEscHandler);
        document.addEventListener('keydown', function (e) {
            keydownEscHandler.call(e.target, e);
        }, true);



        $(window).resize(function () {
            setScrollBar($(this).height());
            if (window.ab_glb.HelpOpened == true) {

                var bottomOffset = 10;
                var footerHeight = $(".navbar-footer").length ? $(".navbar-footer").height() : 35;
                var contentHeight = $(window).height() - $(".apex_header_area").outerHeight() - ($("#apexSupportOption").outerHeight() || 0) - parseInt($("#apexHelpContainer").css("top")) - footerHeight - bottomOffset;
                var heightStr = contentHeight + "px";
                if ($(window).height() < 920 && apex_glb.Project.toLowerCase() != 'ucm_secured') {
                    $("#railContent").css("height", heightStr);
                }

                setApexHelpContainerPosition();
            }

        });
        bindContentClickEvents();
        bindPlatformEvents();

        $('#apex_dropdown_moreoptions').off('focus').on('focus', () => {
            const $dropdown = $('#apexHelpContainer .dropdown_moreoptions .dropdown-content');
            if ($dropdown.is(':visible')) {
                $('#apexHelpContainer .dropdown_moreoptions .dropdown-content').hide();
            }
        });
    };

    var showHelp = function (show) {

        if (show) {

            $('#apexHelpContainer').show();

            var bottomOffset = 10;
            var footerHeight = $(".ba-content-footer").length ? $(".ba-content-footer").height() : 33;
            var contentHeight = $(window).height() - $(".apex_header_area").outerHeight() - ($("#apexSupportOption").outerHeight() || 0) - parseInt($("#apexHelpContainer").css("top")) - footerHeight - bottomOffset;

            if ($(window).height() < 920 && apex_glb.Project.toLowerCase() != 'ucm_secured') {
                $("#railContent").css("height", `${contentHeight}px`);
            }

            if (window.ab_glb.HelpOpened == false) {

                window.ab_glb.HelpOpened = true;
            }

            setApexHelpContainerPosition();

            $('.apex_search_area input#searchquery').focus();

            var firstElementNoSupport = $("#apex_platform_chrome #apex_back_button").hasClass("disabled") || !$("#apex_platform_chrome #apex_back_button").is(":visible") ? $("#apex_platform_chrome #apex_dropdown_moreoptions") : $("#apex_platform_chrome #apex_back_button");

            var lastElementNoSupport = "";
            if (!$("#apexHelpContainer #apex_support_area").is(":visible") && !$("#apexHelpContainer #apexSupportOption").is(":visible")) {
                lastElementNoSupport = findLastVisibleElement($('#apexHelpContainer'));
            }

            var firstElem = !$("#apexHelpContainer #apex_support_area").is(":visible") && !$("#apexHelpContainer #apexSupportOption").is(":visible") ? $(firstElementNoSupport) : $("#apex_platform_chrome #apex_dropdown_moreoptions");
            var lastElem =
                !$("#apexHelpContainer #apex_support_area").is(":visible") && !$("#apexHelpContainer #apexSupportOption").is(":visible") ? $(lastElementNoSupport) :
                    $('.nav-support-options-menu #support-askcommunity-text').is(":visible") ? $('.nav-support-options-menu #support-askcommunity-text') :
                        $('.nav-support-options-menu #support-callme-text').is(":visible") ? $('.nav-support-options-menu #support-callme-text') :
                            $('.nav-support-options-menu #support-phone-text').is(":visible") ? $('.nav-support-options-menu #support-phone-text') :
                                $('.nav-support-options-menu #support-chat-text').is(":visible") ? $('.nav-support-options-menu #support-chat-text') :
                                    $('.nav-support-options-menu #support-phone-text')
                ;

            ApexPlatform.ApexTrapFocus(firstElem, lastElem);
        }
        else {
            $('#apexHelpContainer').hide();
        }

    };

    var setApexHelpContainerPosition = function () {
        var leftOffset = 10;
        var leftPosition = Math.max(leftOffset, window.innerWidth - 390)
        $('#apexHelpContainer').css("left", leftPosition);
        var topPosition = 70;
        if ($(window).height() < 250 && apex_glb.Project.toLowerCase() != 'ucm_secured') {
            topPosition = 10;
        }
        $('#apexHelpContainer').css("top", topPosition);
    }

    var getApexHtmlForSupportOptions = function () {
        var tabIndex = 0;
        if (/Edge/.test(navigator.userAgent)) {
            tabIndex = 1;
        }
        var apexHtml = [
            '<div class="apex_platform_chrome" id="apex_platform_chrome">',
            '   <div data-draggable="true" class="apex_header_area" id="apex_header_area">',
            '       <div id="apex_drag_header" class="apex_header">',
            '            <span id="apex_dropdown_moreoptions" tabindex="0" class="dropdown_moreoptions" role="button" aria-haspopup="true" aria-label="options" title="Options" aria-expanded="false">',
            '	            <div class="dropdown-content" title="" role="menu" >',
            '				            <a href="#" id="homeImage" tabindex="0" role="menuitem" class="HelpTopic" query="ext60065" aria-labelledby="homeText"><span class="homeImage"></span><span id="homeText">Home</span></a>',
            '				            <a href="#" id="newToBingAds" tabindex="0" role="menuitem" class="HelpTopic" query="ext56873"><span class="newToBingAds"></span>New to bing ads?</a>',
            '				            <a id="spinOffWindow" class="spinOffWindow" tabindex="0" role="menuitem"  href="#" url="" aria-labelledby="browserText"><span class="browserImage"></span><span id="browserText">Read article in browser</span></a>',
            '				            <a id="copyTopic" class="copyTopic" tabindex="0" role="menuitem" href="#" url="" aria-labelledby="copyTopicText"><span class="copyTopicImage"></span><span id="copyTopicText">Copy article URL</span></a>',
            '	            </div>',
            '            </span>',
            '            <span tabindex="0" class="close_button" aria-label="Close" role="button" title="Close"></span></div>',
            '   </div>',
            '       <div class="apex_search_area" id="apex_search_area">',
            '          <div class="apex_search_left">',
            '            <span class="back_button disabled" title="Back" aria-label="Back" role="button" aria-disabled="true"></span>',
            '          </div>',
            '          <div class="apex_search_right">',
            '            <span class="apex_search_box">',
            '	            <input type="button" role="button" value="&nbsp;" name="go" aria-label="Search" tabindex="0" class="apex_querybutton" id="searchsubmit"/>',
            '	            <div class="apex_search_input_container"><input type="text" role="combobox" contenteditable="true" autocomplete="off" aria-expanded="false" aria-controls="apex-suggestion-box" aria-autocomplete="both" aria-owns="apex-suggestion-box" aria-activedescendant="" aria-label="Search" placeholder="How can we help?" id="searchquery" maxlength="100" class="apex_querybox"/><span class="sw_dvdr"></span></div>',
            '               <div class="apex_search_icon"></div>',
            '            </span>',
            '          </div>',
            '       </div>',
            '   <div class="apex_content_area"><div class="apex_content_title" id="apex_content_title">Help on this Page</div><div id="apexContentMain" class="viewport support">',
            '       <div id="railContent" class="content"><div id="railContentBody"></div></div>',
            '  <span class="supporttiptext chat v2" style="visibility: hidden;"><p>Mon - Fri: 6 A.M. - 6 P.M. (Pacific Time)<br>Sat: 8 A.M. - 6 P.M. (Pacific Time)</p></span>',
            '       <span class="supporttiptext phone v2" style="visibility: hidden;"><p>Mon - Fri: 6 A.M. - 6 P.M. (Pacific Time)<br>Sat: 8 A.M. - 6 P.M. (Pacific Time)<br>1-800-777-8889</p></span><div id="apexSupportOption">',
            '          <ul class="nav-support-options-menu" role="menu" style="background-color: teal; color: white;">',
            '	            <li class="nav-support-options-chat" role="menuitem">',
            '		            <div class="imageChat"><span ', 'class="support_center"><span id="support-chat-text" role="button" aria-label="Start a Live Chat" tabindex="0">Start a Live Chat!</span><span>&#124;</span>',
            '	                </span></div><div class="supporttip chat"  tabindex="0">Hours</div></li>',
            '	            <li class="nav-support-options-phone v2" role="menuitem">',
            '                   <div class="imagePhone v2"><span class="support_center"><span id="support-phone-text" class="phone v2" role="link" aria-label="Call Support" tabindex="' + tabIndex + '">Call Support</span>',
            '                   </span></div></li>',
            '	            <li class="nav-support-options-callme" role="menuitem">',
            '		            <div class="imageCallme"><span ', 'class="support_center"><span id="support-callme-text" role="button" aria-label="Request a call back" tabindex="0">Request a call back</span>',
            '	                </span></div></li>',
            '	            <li class="nav-support-options-askcommunity" role="menuitem">',
            '		            <div class="imageAskCommunity"><span ', 'class="support_center"><span id="support-askcommunity-text" role="link" aria-label="Ask Community" tabindex="0">Ask Community</span>',
            '	                </span></div></li>',
            '           </ul></div></div></div>',
            '   </div>'
        ];
        return apexHtml;
    }

    var getLiveChatString = function () {
        var retval = "";
        try {
            if (window.ab_glb.SupportOptions.ShowLivePerson == true) {
                retval = "Start a Live chat!";
                retval = apex_glb.LocStrings.LiveOn == undefined ? retval : apex_glb.LocStrings.LiveOn;
                $("#apexSupportOption li.nav-support-options-chat").removeClass("off").addClass("on");
            }
            else {
                retval = "Live chat is not available!"
                retval = apex_glb.LocStrings.LiveOff == undefined ? retval : apex_glb.LocStrings.LiveOff;
                $("#apexSupportOption li.nav-support-options-chat").removeClass("on").addClass("off");
            }
            $("#apexSupportOption li.nav-support-options-chat #support-chat-text").html(retval);
            $("#apexSupportOption li.nav-support-options-chat #support-chat-text").attr('aria-label', retval);
            $('.nav-support-options-phone .supporttip.phone').html(apex_glb.LocStrings.Hours);
        }
        catch (e) {
            $("#apexSupportOption li.nav-support-options-chat").removeClass("on").addClass("off");
            $("#apexSupportOption li.nav-support-options-chat #support-chat-text").html(retval);
            $("#apexSupportOption li.nav-support-options-chat #support-chat-text").attr('aria-label', retval);
            $('.nav-support-options-phone .supporttip.phone').html("Hours");
        }
    };

    function hideSupportTip(e) {
        $('span.supporttiptext').css('visibility', 'hidden');
        document.removeEventListener('click', hideSupportTip, true);
    }

    var addSupportOptionsValuesAndEvents = function () {
        $('div.supporttip, #support-phone-text, span.supporttiptext').unbind("click")
        $('div.supporttip, #support-phone-text, span.supporttiptext').bind("click", function (event) {
            if (event.stopPropagation) { event.stopPropagation() };

            var cls = 'chat';
            if ($(event.target).hasClass(cls) == false) {
                cls = 'phone';
            }

            if ($('span.supporttiptext.' + cls).css('visibility') == 'hidden') {
                $('span.supporttiptext').css('visibility', 'hidden');
                $('span.supporttiptext.' + cls).css('visibility', 'visible');

                /** This section could be moved into its own function **/
                document.addEventListener('click', hideSupportTip, true);
                //$(document.body).on('click', function (e) {
                //    if (e.stopPropagation) { e.stopPropagation() };
                //    var $body = $(this);
                //    $('span.supporttiptext').css('visibility', 'hidden');
                //    $body.off('click');
                //});

                $("#apexHelpContainer .apex_content_area #railContent").off('scroll', hideSupportTip).on('scroll', hideSupportTip);
            }
            else {
                $('span.supporttiptext').css('visibility', 'hidden');
                $(document.body).off('click');
            }

        });

        $('div.supporttip, #support-phone-text, span.supporttiptext').keydown(function (e) {
            var keycode = (e.keyCode ? e.keyCode : (e.which ? e.which : e.charCode));
            if (keycode === 13) { // keycode for enter key
                if (e.preventDefault) { e.preventDefault(); }
                $(e.target).trigger('click');
            }
        });

        $('#apexSupportOption li.nav-support-options-chat div.chat, #apexSupportOption li.nav-support-options-chat .imageChat span:last').hide();

        //show live person
        var element = "#apexSupportOption li.nav-support-options-chat #support-chat-text";
        if (window.ab_glb.SupportOptions.ShowLivePerson == true) {
            $(element).unbind('click').bind('click', function (event) {
                if (event.stopPropagation) { event.stopPropagation() };
                if ($('.livechat-text-block, .ms-support-chat__text-block').length > 0) {
                    $('.livechat-text-block, .ms-support-chat__text-block').trigger('click');
                }
                else {
                    if (window.console && window.console.log)
                        window.console.log("Start Live person here");

                }
            });

            $(element).unbind('keydown').bind('keydown', function (e) {
                var keycode = (e.keyCode ? e.keyCode : (e.which ? e.which : e.charCode));
                if (keycode === 13) { // keycode for enter key
                    if (e.stopPropagation) { e.stopPropagation() };
                    if ($('.livechat-text-block, .ms-support-chat__text-block').length > 0) {
                        $('.livechat-text-block, .ms-support-chat__text-block').trigger('click');
                    }
                    else {
                        if (window.console && window.console.log)
                            window.console.log("Start Live person here");

                    }
                }
            });
        }

        //show phone/email
        if (window.ab_glb.SupportOptions.Phone != null && window.ab_glb.SupportOptions.Phone !== "") {
            var line3 = window.ab_glb.SupportOptions.Phone;
            if (window.ab_glb.SupportOptions.PhoneInterval != null && window.ab_glb.SupportOptions.PhoneInterval.length == 2) {
                var line1 = window.ab_glb.SupportOptions.PhoneInterval[0].Days + ' ' + window.ab_glb.SupportOptions.PhoneInterval[0].Hours + ' ' + window.ab_glb.SupportOptions.PhoneTimeZone;
                var line2 = window.ab_glb.SupportOptions.PhoneInterval[1].Days + ' ' + window.ab_glb.SupportOptions.PhoneInterval[1].Hours + ' ' + window.ab_glb.SupportOptions.PhoneTimeZone;

                $('#apexContentMain .supporttiptext.phone').html('<p><strong>' + line3 + '</strong><br>' + line1 + '<br>' + line2 + '</p>');
            }
            else if (window.ab_glb.SupportOptions.PhoneInterval != null && window.ab_glb.SupportOptions.PhoneInterval.length == 1) {
                var line1 = window.ab_glb.SupportOptions.PhoneInterval[0].Days + ' ' + window.ab_glb.SupportOptions.PhoneInterval[0].Hours + ' ' + window.ab_glb.SupportOptions.PhoneTimeZone;
                $('#apexContentMain .supporttiptext.phone').html('<p><strong>' + line3 + '</strong><br>' + line1 + '</p>');
            }
            $('#apexContentMain .supporttiptext.phone').attr('aria-label', $('#apexContentMain .supporttiptext.phone').html());
            try {
                var ret1 = "Call Support";
                ret1 = apex_glb.LocStrings.CallSupport == undefined ? ret1 : apex_glb.LocStrings.CallSupport;
                $('#apexSupportOption li.nav-support-options-phone #support-phone-text').html(ret1);
                $('#apexSupportOption li.nav-support-options-phone #support-phone-text').attr('aria-label', ret1);

            }
            catch (e) { }
        }
        else if (window.ab_glb.SupportOptions.Email != null && window.ab_glb.SupportOptions.Email !== "") {
            var line1 = window.ab_glb.SupportOptions.EmailInterval[0].Days + ' ' + window.ab_glb.SupportOptions.EmailInterval[0].Hours + window.ab_glb.SupportOptions.EmailTimeZone;
            if ($('#apexSupportOption li.nav-support-options-phone div').hasClass('imageEmail') == false) {
                $('#apexSupportOption li.nav-support-options-phone div.imagePhone').removeClass('imagePhone').addClass('imageEmail')
            }
            $('#apexContentMain .supporttiptext.phone').html('<p>' + line1 + '</p>');
            //$('#apexSupportOption li.nav-support-options-phone')
            $('#apexSupportOption li.nav-support-options-phone #support-phone-text').html(window.ab_glb.SupportOptions.Email);
            $('#apexSupportOption li.nav-support-options-phone #support-phone-text').attr('aria-label', window.ab_glb.SupportOptions.Email);
        } else {
            $('#apexSupportOption li.nav-support-options-phone').hide();
        }

        //show askCommunity
        if (window.ab_glb.SupportOptions.AskCommunity != null && window.ab_glb.SupportOptions.AskCommunity !== "") {
            try {
                $('#apexSupportOption li.nav-support-options-askcommunity').show();
                $('#apexSupportOption li.nav-support-options-askcommunity #support-askcommunity-text').attr('url', window.ab_glb.SupportOptions.AskCommunity)

                var ret1 = "Ask Community";
                ret1 = window.apex_glb.LocStrings.Forum == undefined ? ret1 : window.apex_glb.LocStrings.Forum;
                $('#apexSupportOption li.nav-support-options-askcommunity #support-askcommunity-text').html(ret1);
                $('#apexSupportOption li.nav-support-options-askcommunity #support-askcommunity-text').attr('aria-label', ret1);

            }
            catch (e) { }
            var eleAskCommunity = "#apexSupportOption li.nav-support-options-askcommunity #support-askcommunity-text";

            $(eleAskCommunity).unbind('click').bind('click', function (event) {
                if (event.stopPropagation) { event.stopPropagation() };
                spinOffNewWindow(event);
            });

            $(eleAskCommunity).unbind('keydown').bind('keydown', function (e) {
                var keycode = (e.keyCode ? e.keyCode : (e.which ? e.which : e.charCode));
                if (keycode === 13) { // keycode for enter key
                    if (event.stopPropagation) { event.stopPropagation() };
                    spinOffNewWindow(e);
                }
            });
        }
        else {
            $('#apexSupportOption li.nav-support-options-askcommunity').hide();
        }
        if ($('#requestCallTrigger').length == 1) {
            if (isVisible($('#requestCallTrigger'))) {
                //if ($('#requestCallTrigger').is(':visible')) {
                $('#apexSupportOption li.nav-support-options-callme').css('display', 'block');
                if (isVisible($('#apexSupportOption li.nav-support-options-phone'))) {
                    if (isVisible($('#apexSupportOption li.nav-support-options-askcommunity'))) {
                        $('#apexSupportOption li.nav-support-options-askcommunity').css('display', 'block');
                        $('#apexSupportOption li.nav-support-options-phone, #apexSupportOption li.nav-support-options-chat, #apexSupportOption li.nav-support-options-askcommunity').css('width', '25%');
                    }
                    else {
                        $('#apexSupportOption li.nav-support-options-phone, #apexSupportOption li.nav-support-options-chat').css('width', '33%');
                    }
                }
                else {
                    if (isVisible($('#apexSupportOption li.nav-support-options-askcommunity'))) {
                        $('#apexSupportOption li.nav-support-options-askcommunity').css('display', 'block');
                        $('#apexSupportOption li.nav-support-options-chat, #apexSupportOption li.nav-support-options-callme, #apexSupportOption li.nav-support-options-askcommunity').css('width', '33%');
                    }
                    else {
                        $('#apexSupportOption li.nav-support-options-callme').css('width', '50%');
                    }
                }
                $('#apexContentMain .supporttiptext.v2').css("left", '-31px');

                var eleCallme = "#apexSupportOption li.nav-support-options-callme #support-callme-text";
                $(eleCallme).unbind('click').bind('click', function (event) {
                    if (event.stopPropagation) { event.stopPropagation() };
                    $('#requestCallTrigger').trigger('click');
                });

                $(eleCallme).unbind('keydown').bind('keydown', function (e) {
                    var keycode = (e.keyCode ? e.keyCode : (e.which ? e.which : e.charCode));
                    if (keycode === 13) { // keycode for enter key
                        if (event.stopPropagation) { event.stopPropagation() };
                        $('#requestCallTrigger').trigger('click');
                    }
                });
                try {
                    var retval = "Request a call back";
                    retval = apex_glb.LocStrings.ScheduleCall == undefined ? retval : apex_glb.LocStrings.ScheduleCall;
                    $("#apexSupportOption li.nav-support-options-callme #support-callme-text").html(retval);
                    $("#apexSupportOption li.nav-support-options-callme #support-callme-text").attr('aria-label', retval);

                }
                catch (e) { }
            }

        }
    }

    var getApexHtmlForNoSupportOptions = function () {
        var apexHtml = [
            '<div class="apex_platform_chrome" id="apex_platform_chrome">',
            '   <div class="apex_header_area" id="apex_header_area">',
            '       <div id="apex_drag_header" class="apex_header">',
            '            <span id="apex_dropdown_moreoptions" tabindex="0" class="dropdown_moreoptions" role="button" aria-haspopup="true" aria-label="options" aria-expanded="false">',
            '	            <div class="dropdown-content" title="" role="menu" >',
            '				            <a href="#" id="homeImage" tabindex="0" role="menuitem" class="HelpTopic" query="ext60065" aria-labelledby="homeText"><span class="homeImage"></span><span id="homeText">Home</span></a>',
            '				            <a href="#" id="newToBingAds" tabindex="0" role="menuitem" class="HelpTopic" query="ext56873"><span class="newToBingAds"></span>New to bing ads?</a>',
            '				            <a href="#" id="videoGallery" tabindex="0" role="menuitem" class="HelpTopic" query="ext51193"><span class="videoGallery"></span>Video Gallery</a>',
            '				            <a id="spinOffWindow" class="spinOffWindow" tabindex="0" role="menuitem"  href="#" url="" aria-labelledby="browserText"><span class="browserImage"></span><span id="browserText">Read article in browser</span></a>',
            '				            <a id="copyTopic" class="copyTopic" tabindex="0" role="menuitem" href="#" url="" aria-labelledby="copyTopicText"><span class="copyTopicImage"></span><span id="copyTopicText">Copy article URL</span></a>',
            '	            </div>',
            '            </span>',
            '            <span tabindex="0" class="close_button" aria-label="Close" role="button"></span></div>',
            '   </div>',
            '       <div class="apex_search_area" id="apex_search_area">',
            '          <div class="apex_search_left">',
            '            <span class="back_button disabled" title="Back" aria-label="Back" role="button" aria-disabled="true"></span>',
            '          </div>',
            '          <div class="apex_search_right">',
            '            <span class="apex_search_box">',
            '	            <input type="button" role="button" value="&nbsp;" name="go" aria-label="Search" tabindex="0" class="apex_querybutton" id="searchsubmit"/>',
            '	            <div class="apex_search_input_container"><input type="text" role="combobox" contenteditable="true" autocomplete="off" aria-autocomplete="both" aria-expanded="false" aria-controls="apex-suggestion-box" aria-owns="apex-suggestion-box" aria-activedescendant="" aria-label="Search" placeholder="How can we help?" id="searchquery" maxlength="100" class="apex_querybox"/><span class="sw_dvdr"></span></div>',
            '               <div class="apex_search_icon"></div>',
            '            </span>',
            '          </div>',
            '       </div>',
            '   <div class="apex_content_area"><div class="apex_content_title" id="apex_content_title">Help on this Page</div><div id="apexContentMain" class="viewport nosupport"><div id="railContent" class="content"></div></div></div>',
            '   <div class="apex_support_area" id="apex_support_area">',
            '       <div class="support"><span class="support_label" role="link" aria-lable="contact us" tabindex="0">CONTACT US</span><span class="support_dropdown"></span></div>',
            '       <div class="supportDD" style="display:none;"><div id="lpButton3"></div></div>',
            '   </div>',
            '</div>'
        ];
        return apexHtml;
    }

    var getApexUCMHtmlForNoSupportOptions = function () {
        var apexHtml = [
            '<div class="apex_platform_chrome" id="apex_platform_chrome">',
            '   <div class="apex_header_area" id="apex_header_area">',
            '       <div id="apex_drag_header" class="apex_header">',
            '            <span id="apex_back_button" class="back_button disabled" title="Back" aria-label="Back" role="button"></span>',
            '            <span id="apex_dropdown_moreoptions" tabindex="0" class="dropdown_moreoptions" role="button" aria-haspopup="true" aria-label="options" aria-expanded="false">',
            '	            <div class="dropdown-content" title="" role="menu" >',
            '				            <a href="#" id="homeImage" tabindex="0" role="menuitem"  class="HelpTopic" query="ext51022" aria-labelledby="homeText"><span class="homeImage"></span><span id="homeText">Home</span></a>',
            '				            <a href="#" id="newToBingAds" tabindex="0" role="menuitem"  class="HelpTopic" query="ext56873"><span class="newToBingAds"></span>New to bing ads?</a>',
            '				            <a href="#" id="videoGallery" tabindex="0" role="menuitem"  class="HelpTopic" query="ext51193"><span class="videoGallery"></span>Video Gallery</a>',
            '				            <a id="spinOffWindow" class="spinOffWindow" tabindex="0" role="menuitem"  href="#" url="" aria-labelledby="browserText"><span class="browserImage"></span><span id="browserText">Read article in browser</span></a>',
            '				            <a id="copyTopic" class="copyTopic" tabindex="0" role="menuitem" href="#" url="" aria-labelledby="copyTopicText"><span class="copyTopicImage"></span><span id="copyTopicText">Copy article URL</span></a>',
            '	            </div>',
            '            </span>',
            '            <span tabindex="0" class="expand_button" aria-label="Expand" role="button"></span>',
            '            <span tabindex="0" class="close_button" aria-label="Close" role="button"></span>',
            '       </div>',
            '   </div>',
            '   <div class="ucm_header_area">',
            '       <h1 id="ucm_help_header">UCM Help</h1>',
            '   </div>',
            '   <div class="apex_search_area" id="apex_search_area">',
            '       <div class="apex_search_right">',
            '           <span class="apex_search_box">',
            '	            <input type="button" role="button" value="&nbsp;" name="go" aria-label="Search" tabindex="0" class="apex_querybutton" id="searchsubmit"/>',
            '	            <input type="text" role="combobox" autocomplete="off" aria-autocomplete="both" aria-expanded="false" aria-controls="apex-suggestion-box" aria-owns="apex-suggestion-box" aria-activedescendant="" aria-label="Search" placeholder="How can we help?" id="searchquery" maxlength="100" class="apex_querybox"/><span class="sw_dvdr"></span>',
            '           </span>',
            '       </div>',
            '   </div>',
            '   <div class="apex_content_area"><div class="apex_content_title" id="apex_content_title">Help on this Page</div><div id="apexContentMain" class="viewport nosupport"><div id="railContent" class="content"></div></div></div>',
            '   <div class="apex_support_area" id="apex_support_area">',
            '       <div class="support"><span class="support_label" role="link" aria-lable="contact us" tabindex="0">CONTACT US</span><span class="support_dropdown"></span></div>',
            '       <div class="supportDD" style="display:none;"><div id="lpButton3"></div></div>',
            '   </div>',
            '</div>'
        ];
        return apexHtml;
    }

    var buildRailHelpLayout = function () {
        var apexHtml = [];
        //var apexHtml = [
        //        '<div class="apex_platform_chrome" id="apex_platform_chrome"><div class="apex_header_area" id="apex_header_area">',
        //        '<div class="apex_header"><span tabindex="0" class="close_button"></span></div>',
        //        '<div class="apex_search_area" id="apex_search_area"><div class="apex_search_left"><span class="back_button disabled" title="Back"></span><span tabindex="0" class="back_button_dots"  title="More options">',
        //        '<div class="dropdown-content"><a href="#" id="homeImage" class="HelpTopic" query="ext51022"><span class="homeImage"></span><span id="homeText">Home</span></a>',
        //        '<a href="#" id="newToBingAds" class="HelpTopic" query="ext56873"><span class="newToBingAds"></span>New to bing ads?</a>',
        //        '<a href="#" id="videoGallery" class="HelpTopic" query="ext51193"><span class="videoGallery"></span>Video Gallery</a>',
        //        '<a id="spinOffWindow" class="spinOffWindow" href="#" url=""><span class="browserImage"></span><span id="browserText">Read article in browser</span></a>',
        //        '<a id="copyTopic" class="copyTopic" href="#" url=""><span class="copyTopicImage"></span><span id="copyTopicText">Copy article URL</span></a></div></span></div><div class="apex_search_right">',
        //        '<input type="text" role="Search" autocomplete="off" title="How can we help?" placeholder="How can we help?" id="searchquery" maxlength="100" class="apex_querybox"/><span class="sw_dvdr"></span>',
        //        '<input type="button" role="Search" value="" name="go" tabindex="0" title="How can we help?" class="apex_querybutton" id="searchsubmit"/></div></div></div>',
        //        '<div class="apex_content_area"><div class="apex_content_title" id="apex_content_title">Help on this Page</div><div id="apexContentMain" class="viewport"><div id="railContent" class="content"></div></div></div><br />',
        //        '<div class="apex_support_area" id="apex_support_area">',
        //        '<div class="support"><span class="support_label"  tabindex="0">CONTACT US</span><span class="support_dropdown"></span></div></div>'
        //];

        //if (window.ab_glb.SupportOptions == null) {
        //    apexHtml = getApexHtmlForNoSupportOptions()
        //}
        //else {
        //    window.ab_glb.ContentRootElement = '#railContentBody'
        //    apexHtml = getApexHtmlForSupportOptions();
        //}

        var viewId = $('[RailViewID]')[0] == undefined ? RailHelpController.GetViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
        $('#railHelpInputs').attr('ViewName', viewId);
        $(railHtmlRoot).hide();
        $(railHtmlRoot).remove('.apex_platform_chrome');
        $(railHtmlRoot).attr('role', 'dialog');
        $(railHtmlRoot).attr('aria-label', apex_glb.LocStrings.FloatingHelpPanel);
        //$(apexHtml.join('')).appendTo(railHtmlRoot);

        // If else UCM - insert HTML into #apexHelpPanel container
        if ($("#apexHelpPanel").length == 0) {
            if (ab_glb.SupportOptions == null) {
                apexHtml = getApexHtmlForNoSupportOptions();
            }
            else {
                ab_glb.ContentRootElement = '#railContentBody'
                apexHtml = getApexHtmlForSupportOptions();
            }
            $(apexHtml.join('')).appendTo(railHtmlRoot);
        }
        else {
            $(railHtmlRoot).show();
            apexHtml = getApexUCMHtmlForNoSupportOptions();
            var ucmABHtml = '<div id="apexHelpContainer" class="apex-help-container railhtml_main">' + apexHtml.join('') + '</div>';
            $('#apexHelpPanel').html(ucmABHtml);
        }

        if (apex_glb.Authorize == true) {
            $(railHtmlRoot + ' #spinOffWindow, ' + railHtmlRoot + ' #copyTopic').hide();
        }
        bindChromeClickEvents();
        //debugger;
        if ($('#apex-suggestion-box').length == 0 && apex_glb.Suggestions !== null) {
            try {
                $('#searchquery').suggestionBox({
                    filter: true,
                    widthAdjustment: -8,
                    leftOffset: 0,
                    topOffset: 1,
                }).addSuggestions(apex_glb.Suggestions);
            } catch (ex) { };
        }
        //add RTL specific style
        addRTLSpecificStyles();
        if (window.ab_glb.SupportOptions !== null) {
            if (typeof window.ab_glb.SupportOptions.template === 'string') {
                $('#apexSupportOption').html(window.ab_glb.SupportOptions.template);
            } else {
                addSupportOptionsValuesAndEvents();
            }
        }

        if (window.apex_glb.renderSearchInputIcon) {
            window.apex_glb.renderSearchInputIcon($('.apex_search_icon').get(0));
        }
        //showHelp(true);
    };

    //
    // private function for debugging
    //
    var debug = function ($obj) {
        if (window.console && window.console.log)
            window.console.log($obj);
    };

    var replaceAll = function (input, replace, with_this) {
        return input.replace(new RegExp(replace, 'g'), with_this);
    };

    var isNumber = function (n) {
        return parseFloat(n) == n;
    };

    var getViewName = function () {
        var viewname = "Default";
        var lochref = location.href;
        var indexHash = lochref.indexOf('#', 0);
        var pathname = location.pathname;
        if (indexHash >= 0) {
            var indexQn = lochref.indexOf('?', indexHash);
            pathname = lochref.substring(indexHash, indexQn);
        }

        var index = pathname.indexOf('.aspx', 0);
        var paths;
        var length;
        var minLength = 2;
        //MVC 
        if (index < 0) {
            paths = pathname.split('/');
            length = paths.length;
            for (var i = length - 1; i > 0; i--) {
                if (isNumber(paths[i])) {
                    paths.splice(i, 1);
                }
            }
            length = paths.length;
        }
        else { //ASPX
            var aspxname = pathname.substr(0, index);
            paths = aspxname.split('/');
            length = paths.length;
            minLength = 1;
        }

        if (length > minLength) {
            if ($.trim(paths[length - 2]) != "") {
                viewname = paths[length - 2];
                if ($.trim(paths[length - 1]) != "") {
                    viewname = viewname + '_' + paths[length - 1];
                };
            } else if ($.trim(paths[length - 1]) != "") {
                viewname = paths[length - 1];
            };
        }
        else if (length > (minLength - 1)) {
            if ($.trim(paths[length - 1]) != "") {
                viewname = paths[length - 1];
            };
        }
        var viewIdHtml = '<div railviewid="' + viewname + '" style="display:none"></div>';
        if ($('[RailViewID]')[0] == undefined) $('body').append(viewIdHtml);
        return viewname;
    };


    var getGlobalHelpInformation = function () {
        window.ab_glb.ApexAPIEndPoint = $.trim($("#railHelpInputs").attr("helpurl"));
        window.ab_glb.CDNEndPoint = $.trim($("#railHelpInputs").attr("cdnEndPoint"));
        window.ab_glb.HelpProduct = $.trim($("#railHelpInputs").attr("Product"));
        window.ab_glb.HelpProject = $.trim($("#railHelpInputs").attr("Project"));
        window.ab_glb.HelpMarket = $.trim($("#railHelpInputs").attr("Market"));
        window.ab_glb.SupportMarket = $.trim($("#railHelpInputs").attr("SupportMarket")); //window.ab_glb.HelpMarket;
        window.ab_glb.HelpLanguage = $.trim($("#railHelpInputs").attr("Language"));

        if (window.ab_glb.HelpProject == undefined || $.trim(window.ab_glb.HelpProject) == "") {

            window.ab_glb.HelpProject = "";
        }
        if ((window.ab_glb.HelpProduct == undefined || $.trim(window.ab_glb.HelpProduct) == "") && $.trim(window.ab_glb.HelpProject) != "") {

            window.ab_glb.HelpProduct = window.ab_glb.HelpProject;
        }
        if (window.ab_glb.HelpLanguage == undefined || $.trim(window.ab_glb.HelpLanguage) == "") {
            window.ab_glb.HelpLanguage = window.ab_glb.HelpMarket;
        }
        if (window.ab_glb.SupportMarket == undefined || $.trim(window.ab_glb.SupportMarket) == "") {
            window.ab_glb.SupportMarket = window.ab_glb.HelpMarket;
        }
        window.ab_glb.HelpSku = $.trim($("#railHelpInputs").attr("Sku"));

        // initialize with default loc strings
        var locStr = '{"LocStrings":{"About":"About this page","Help":"Help", "Community":"Community","How":"How do I?","Search":"How can we help?","Videos":"Watch a video","New":"Whats New","RCQ":"Everybody asking(RCQ)","Issues":"Known Issues","BingYahoo":"Will my ads display on both Bing and Yahoo?","Chat":"Contact support","Support":"Support","Loading":"Loading","More":"More...","Less":"Less...","Rating1":"Absolutely awful!","Rating2":"Really? You can do better…","Rating3":"It’s alright.","Rating4":"Nicely done.","Rating5":"Pure genius!","QueryDefault":"Search Help","Yes":"Yes","No":"No","DidHelpYou":"Did this help you?", "ShowAB":"Show Answer Bar", "HideAB":"Hide Answer Bar", "Content":"content", "Video":"video", "Back":"Back","Next":"Forward", "OF":"of", "CopyUrl":"Copy Url", "EmailUrl":"Email Url", "Pinned":"Keep on top", "UnPinned":"Not on top","CommunityText":"Community", "Header":"Bing Ads Help","PrintTopic":"Print article","GetStarted":"Get Started","CommunityFooter":"Not finding what you are looking for? Check out the {0}Bing Ads Community blog and forums.{1}"}}';
        var data = null;
        if (typeof JSON != 'undefined') {
            data = jQuery.parseJSON(locStr);
        }
        else {
            data = eval("(" + locStr + ")");
        }
        window.ab_glb.LocStrings = data.LocStrings;

        enableRTLLanguage();
        PopupController.GetGlobalHelpInformation()
    };

    var isRailBarEnabled = function () {

        if ($('input#railHelpInputs').is('.railHelpInputs')) {
            var enable = $.trim($("#railHelpInputs").attr("Enable"));
            if ((enable != undefined) && (enable != null)) {
                return (enable.toLowerCase() == "true");
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    };

    var setBrowserSpecificClassToRoot = function () {
        //add custom CSS overrides for browser compatibility
        //if ($.browser.msie) {
        //    var msieversion = parseInt($.browser.version);
        //    if (msieversion < 9) {
        //        $(railHtmlRoot).addClass("IE" + msieversion);
        //    }
        //}
        //else if ($.browser.webkit) {
        //    $(railHtmlRoot).addClass("WK");
        //}
        //else if ($.browser.mozilla) {
        //    $(railHtmlRoot).addClass("FF");
        //}
        $(railHtmlRoot).addClass("WK");
    };

    var addRTLSpecificStyles = function () {
        if (window.ab_glb.IsBIDIMarket == false) return false;
        var railHelpRtlCssPath = window.ab_glb.CDNEndPoint + "/resources/content/styles/apex.ar.css?v=2.00128";
        var headId = $('head')[0];
        var link = '<link href="' + railHelpRtlCssPath + '" rel="stylesheet" type="text/css" />';
        $(link).appendTo(headId);
        return false;
    };

    var linkStylesFromCSSFiles = function () {
        var railHelpCssPath = window.ab_glb.CDNEndPoint + "/resources/content/styles/apex.embed.v3.min.css?v=3.00.0007";
        var headId = $('head')[0];
        var link = '<link href="' + railHelpCssPath + '" rel="stylesheet" type="text/css" />';
        $(link).appendTo(headId);

        //add class for root element for styles
        setStylesForRootElement();

    };

    //add styles for root element
    var setStylesForRootElement = function () {
        $(railHtmlRoot).addClass('railhtml_main');
        if ($('.apex-help-container').length > 0) {
            $('#apex_platform_chrome').css('position', 'absolute');

        }
        else {
            $('#apex_platform_chrome').css('position', 'fixed');
        }

        setBrowserSpecificClassToRoot();
    };

    //build related articles
    var buildRelatedArticlesRows = function (data) {
        var html = '';
        var rowItems = ['<h2 class="HEADING" id="see_more_text">See also...</h2><ul>'];
        var index = 1;
        if (data.Content.RelatedTopics != null && data.Content.RelatedTopics.length > 0) {
            $.each(data.Content.RelatedTopics, function (i, val) {
                if (val.Url != null) {
                    var row = '<li><a class="HelpTopic" href="#" role="link" query="' + val.Query + '" >' + val.Title + '</a></li>';
                    rowItems[index++] = row;
                }
            });
        }
        if (data.Content.RelatedVideos != null && data.Content.RelatedVideos.length > 0) {
            $.each(data.Content.RelatedVideos, function (i, val) {
                var row = '<li style="list-style-type: none;"><span class="abLaunchVideo" tabindex="0" role="link" videoid="' + val.VideoId + '" op_videoid="' + val.OP_VideoId + '"><span class="imageVideo"></span>' + val.Title + '</span></li>';
                rowItems[index++] = row;
            });
        }
        if (index > 1) {
            rowItems[index++] = '</ul>';
            html = rowItems.join('');
        }
        return html.toString();
    };


    //rowType = 0=>Tour, 1=>Video, 2=>Article, 3=>Search Rows
    var buildContentRows = function (data, rowType) {

        var label = '';
        var cls = '';
        var imgCls = '';
        var html = '';
        var rowItems = [];
        switch (rowType) {
            case 0:
                label = apex_glb.LocStrings.Tours == "undefined" ? "Tours" : apex_glb.LocStrings.Tours;
                cls = "Tour";
                imgCls = "imageTour"; //apex_glb.EndPoint + '/Resources/content/styles/Images/Tour.png';
                break;
            case 1:
                label = apex_glb.LocStrings.Video1 == "undefined" ? "Videos" : apex_glb.LocStrings.Video1;
                cls = "Video";
                imgCls = "imageVideo"; //apex_glb.EndPoint + '/Resources/content/styles/Images/Video.png';
                break;
            case 2:
                label = apex_glb.LocStrings.Articles == "undefined" ? "Articles" : apex_glb.LocStrings.Articles;
                cls = "Articles";
                imgCls = "imageArticles"; //apex_glb.EndPoint + '/Resources/content/styles/Images/article.png';
                break;

        }
        if (rowType <= 2) {
            //$('#apex_content_title').html(apex_glb.LocStrings.HelpOnThisPage);
            $('#apex_content_title').html('');
            $('#apex_content_title').hide();
            var head = '<div class="hSearchLabel"><span class="' + imgCls + '"></span><span tabindex="0" aria-lable="' + label + '" role="heading">' + label + '</span></div>';
            var rowItems = [head];
        }
        else {
            $('#apex_content_title').html(apex_glb.LocStrings.SearchResults);
            $('#apex_content_title').show();
            cls = "Search";
            imgCls = "imageSearch"; //apex_glb.EndPoint + '/Resources/content/styles/Images/Video.png';
        }
        //$('.apex_content_area #railContent').css('overflow-x', 'hidden');
        //var rowTemplate = [
        //    '<div class="hSearchRow"><div class="SearchTitle abc-ellipsis">',
        //    '<span tabindex="0" role="Link" topic="{0}" secretkey="{1}" row="{2}">{3}</span>',
        //    '</div></div><hr />'
        //];

        if (data != null && (data.length > 0 || rowType == 0)) {
            var index = 1;
            $.each(data, function (i, val) {
                var video = '';
                var imgVideo = '';
                var row = '';
                if (cls == 'Tour') {
                    row = '<div class="hSearchRow ' + cls + '"><div class="SearchTitle">' +
                        '<span tabindex="0" role="link" wid="' + i + '" row="' + index + '">' + val + '</span></div><hr/></div>';
                    //rowItems[i + 1] = row;
                }
                else {
                    if (cls == 'Video') {
                        video = '" videoId="' + val.VideoId + '" op_videoId="' + val.OP_VideoId;
                        row = '<div class="hSearchRow ' + cls + '"><div class="SearchTitle">' +
                            '<span tabindex="0" role="link" topic="' + val.Filename + '" secretkey="' +
                            val.SecretKey + '" row="' + val.Row + video + '">' + imgVideo + val.Title + '</span></div><hr/></div>';
                    }
                    else if (cls == 'Search') {
                        if (val.VideoId != null || val.VideoId == '') {
                            cls += ' Video'
                            video = '" videoId="' + val.VideoId + '" op_videoId="' + val.OP_VideoId;
                            imgVideo = '<span class="' + imgCls + '"></span>';
                            row = '<div class="hSearchRow ' + cls + '"><div class="SearchTitle">' +
                                '<span tabindex="0" role="link" topic="' + val.Filename + '" secretkey="' +
                                val.SecretKey + '" row="' + val.Row + video + '">' + imgVideo + val.Title + '</span></div><hr/></div>';
                        }
                        else {

                            cls += ' Articles';
                            row = '<div class="hSearchRow ' + cls + '"><div class="SearchTitle">' +
                                '<a tabindex="0" role="link" href="' + apex_glb.EndPoint + val.Href + '" topic="' + val.Filename + '" secretkey="' +
                                val.SecretKey + '" row="' + val.Row + video + '">' + imgVideo + val.Title + '</a></div><hr/></div>';
                        }
                    }
                    else {
                        row = '<div class="hSearchRow ' + cls + '"><div class="SearchTitle">' +
                            '<a tabindex="0" role="link" href="' + apex_glb.EndPoint + val.Href + '" topic="' + val.Filename + '" secretkey="' +
                            val.SecretKey + '" row="' + val.Row + video + '">' + imgVideo + val.Title + '</a></div><hr/></div>';
                    }
                    //row = '<div class="hSearchRow ' + cls + '"><div class="SearchTitle">' +
                    //      '<span tabindex="0" role="Link" topic="' + val.Filename + '" secretkey="' +
                    //      val.SecretKey + '" row="' + val.Row + video + '">' + imgVideo + val.Title + '</span></div><hr/></div>';
                    var clsArr = cls.split(' ');
                    if (clsArr.length == 2) {
                        cls = clsArr[0];
                    }
                    //rowItems[i + 1] = row;
                }
                rowItems[index++] = row;
            });
            if (index > 1) {
                html = rowItems.join(''); //.appendTo($('#railContent'));
            }
        }
        return html.toString();
    };

    var buildContent = function (data) {
        var rowItems = [];
        var index = 0;
        if (data.Content == null || data.Content == undefined) {
            var articles = buildContentRows(data.Topics, 2);
            var videos = buildContentRows(data.Videos, 1);
            var tours = buildContentRows(apex_glb.Tours, 0);
            if (articles != '') rowItems[index++] = articles;
            if (videos != '') rowItems[index++] = videos;
            if (tours != '') rowItems[index++] = tours;

            //$('#apexHelpContainer .apex_content_area #railContent').css('overflow-x', 'hidden');
        }
        else {
            var content = data.Content.Content;
            var path = "/Resources/Content/styles/images/";
            var new_path = apex_glb.EndPoint + "/Resources/Content/styles/images/";
            replaceAll(content, path, new_path);

            rowItems[index++] = content;

            //rowItems[index++] = buildRelatedArticlesRows(data.Content.RelatedTopics, 2);
            //rowItems[index++] = buildRelatedArticlesRows(data.Content.RelatedVideos, 1);
            //$('#apexHelpContainer .apex_content_area #railContent').css('overflow-x', 'auto !important');
        }

        $('#apexHelpContainer ' + window.ab_glb.ContentRootElement).html('');
        html = rowItems.join('');
        return html.toString();
    };

    var buildNavGroups = function (data) {

    };

    var updateUrlPaths = function () {
        $.each($('#apexHelpContainer ' + window.ab_glb.ContentRootElement + ' a[href_new]'), function (index, elem) {
            if ($(elem).attr('targetId') !== undefined) {
                var targetId = $(elem).attr('targetid');
                $(elem).attr('href', targetId);
            }
            else if (!$(elem).parent().hasClass('expando')) {
                var val = $(elem).attr('href_new');
                var token = '/';
                var viewId = $('[RailViewID]')[0] == undefined ? 'none' : $('[RailViewID]')[0].attributes['railviewid'].value;
                if (apex_glb.EndPoint.match("/$") == "/") token = '';
                $(elem).attr('href', apex_glb.EndPoint + token + val + '/' + apex_glb.SupportMarket + '/#ext:' + viewId);
                $(elem).attr('target', '_apexPlatformHelp');
                //$(elem).unbind('click');
            }
            else {
                var val = $(elem).attr('href');
                var token = '/';

                if (apex_glb.EndPoint.match("/$") == "/") token = '';
                $(elem).attr('href', apex_glb.EndPoint + '/' + val);
            };
        });
        $.each($('#apexHelpContainer ' + window.ab_glb.ContentRootElement + ' .expando-head-bg img'), function (index, elem) {
            var val = $(elem).attr('src');
            var token = '/';

            if (apex_glb.EndPoint.match("/$") == "/") token = '';
            $(elem).attr('src', apex_glb.EndPoint + val);
        });
        //try{
        //    $('#railContent').perfectScrollbar({
        //        suppressScrollX: true,
        //        scrollYMarginOffset:30
        //    });
        //}
        //catch(e){};
        var viewId = $('[RailViewID]')[0] == undefined ? RailHelpController.GetViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
        var spinUrl = apex_glb.EndPoint + '/#apex/' + apex_glb.ProjectAlias + '/' + apex_glb.Language + '/' + apex_glb.CurrentQuery + '/1/' + apex_glb.SupportMarket + '/#ext:' + viewId;
        $('#apexHelpContainer #spinOffWindow, #apexHelpContainer #copyTopic').attr('url', spinUrl);

        var fullBrowserElem = $('#apexHelpContainer .fullBrowserOnly');
        if (fullBrowserElem.length > 0) {
            var hideExternal = $('#apexHelpContainer .hideExternalLink');
            if (hideExternal.length == 0) {
                var newWindowHtml = '<a id="spinOffWindow" class="spinOffWindow" href="#" url="' + spinUrl + '"><span class="browserImage"></span><span id="browserText">' + apex_glb.LocStrings.OpenNewWindowLarge + '</span></a>';
                $(newWindowHtml).insertBefore(fullBrowserElem[0]);
            }
            //$(newWindowHtml).insertBefore($(fullBrowserElem).parentsUntil('#apexHelpContainer')[0]);
        }
        if ($('#cntnt div.spinOffWindowPersist').length > 0) {
            //if (apex_glb.Project.toLowerCase() == 'ucm_secured') {
            //    $('#cntnt div').removeClass('spinOffWindowPersist');
            //}
            $('#cntnt div.spinOffWindowPersist').attr('title', apex_glb.LocStrings.OpenNewWindow);
            $('#cntnt div.spinOffWindowPersist').attr('tabindex', "0");
            $('#cntnt div.spinOffWindowPersist').attr('aria-label', apex_glb.LocStrings.OpenNewWindow);
            $('#cntnt div.spinOffWindowPersist').attr('role', 'link');

            $('#cntnt div.spinOffWindowPersist').unbind('click');
            $('#cntnt div.spinOffWindowPersist').bind('click', function (e) {
                if (e.preventDefault) { e.preventDefault(); }
                $('.dropdown-content a#spinOffWindow').trigger('click');
            });

            $('#cntnt div.spinOffWindowPersist').unbind('keypress');
            $('#cntnt div.spinOffWindowPersist').bind('keypress', function (event) {
                if (event.which === 13) {
                    $(event.target).trigger('click');
                }
            });
        }
        dragElement(document.getElementById(("apexHelpContainer")));
        setScrollBar();
    };

    var handleUCMDropdownUpdate = function () {

        $('#apexHelpContainer .dropdown_moreoptions  a#homeImage').attr('query', 'ext72011');

        //$('#apexHelpContainer .dropdown_moreoptions  a#newToBingAds').attr('query', 'ext72019');
        if (window.WorkspaceId) {
            var workspaceViewMapping = ["ext72019", "ext72085", "ext72089", "ext72084"];
            var queryId = workspaceViewMapping[window.WorkspaceId - 1];
            $('#apexHelpContainer .dropdown_moreoptions  a#newToBingAds').attr('query', queryId);
        }
        else {
            $('#apexHelpContainer .dropdown_moreoptions  a#newToBingAds').attr('query', 'ext72019');
        }

        $('#apexHelpContainer .dropdown_moreoptions a#newToBingAds').html(apex_glb.LocStrings.New);  //what's new
        $('#apexHelpContainer .dropdown_moreoptions a#videoGallery').removeClass('HelpTopic');
        $('#apexHelpContainer .dropdown_moreoptions  a#videoGallery').attr('href', 'https://go.microsoft.com/fwlink/?linkid=848221');
        var trainingPortal = '<a href="https://go.microsoft.com/fwlink/?linkid=2233763&clcid=0x409" id="trainingPortal" role="menuitem"></a>';
        var howTo = '<a href="https://go.microsoft.com/fwlink/?linkid=848222" id="howToAccessUCM" role="menuitem"></a>';
        if ($('#apexHelpContainer .dropdown_moreoptions a#howToAccessUCM').length == 0) {
            $(howTo).insertAfter('#apexHelpContainer .dropdown_moreoptions  a#newToBingAds');
        }
        $('#apexHelpContainer .dropdown_moreoptions a#howToAccessUCM').html(apex_glb.LocStrings.HowToAccessUCM);

        if ($('#apexHelpContainer .dropdown_moreoptions a#trainingPortal').length == 0) {
            $(trainingPortal).insertAfter('#apexHelpContainer .dropdown_moreoptions  a#newToBingAds');
        }
        $('#apexHelpContainer .dropdown_moreoptions a#trainingPortal').html(apex_glb.LocStrings.TrainingPortal);

        //$('#apexHelpContainer .dropdown_moreoptions  a#videoGallery').off("click");
        //$('#apexHelpContainer .dropdown_moreoptions  a#videoGallery').on("click", function (e) {
        //    if (e.preventDefault) { e.preventDefault(); }
        //    if (e.stopPropagation) { e.stopPropagation() };
        //    $('#apexHelpContainer .dropdown_moreoptions .dropdown-content').hide();
        //    window.open(this.href, "_apexVideoGallery");
        //});
        $('#apexHelpContainer .dropdown_moreoptions  a#howToAccessUCM').off("click");
        $('#apexHelpContainer .dropdown_moreoptions a#howToAccessUCM').on("click", function (e) {
            if (e.preventDefault) { e.preventDefault(); }
            if (e.stopPropagation) { e.stopPropagation() };
            $('#apexHelpContainer .dropdown_moreoptions .dropdown-content').hide();
            window.open(this.href, "_apexhowToAccessUCM");
        });
        $('#apexHelpContainer .dropdown_moreoptions  a#trainingPortal').off("click");
        $('#apexHelpContainer .dropdown_moreoptions a#trainingPortal').on("click", function (e) {
            if (e.preventDefault) { e.preventDefault(); }
            if (e.stopPropagation) { e.stopPropagation() };
            $('#apexHelpContainer .dropdown_moreoptions .dropdown-content').hide();
            window.open(this.href, "_apextrainingPortal");
        });

    };

    var handleDMCDropdownUpdate = function () {

        $('#apexHelpContainer .dropdown_moreoptions  a#homeImage').attr('query', 'ext30000');
        $('#apexHelpContainer .dropdown_moreoptions  a#newToBingAds').attr('query', 'ext30002');
        $('#apexHelpContainer .dropdown_moreoptions  a#videoGallery').attr('query', 'ext30023');

        newToDMC = "New to Digital Marketing?"
        newToDMC = apex_glb.LocStrings.NewToDMC == undefined ? newToDMC : apex_glb.LocStrings.NewToDMC;
        $('#apexHelpContainer .dropdown_moreoptions a#newToBingAds').html(newToDMC);

    };

    var loadOnDemandContent = function() {
        try {

            if (apex_glb.Authorize != true) {
                if ($('.ApexOndemandContent').length != 0) {
                    var filename = $('.ApexOndemandContent').attr('ondemand_filename') + '.htm';
                    var url = window.apex_glb.EndPoint + "/api/" + window.apex_glb.APIController + "/ApexRawContent";
                    var onDemandInput = {
                        'project': apex_glb.Project,
                        'language': apex_glb.Market,
                        'filename': filename
                    };

                    $.ajax({
                        url: url,
                        type: "GET",
                        data: onDemandInput,
                        cache: true,
                        success: function (data) {
                            $('.ApexOndemandContent').parent().append(data);
                        }
                    });
                }
            }
        }
        catch (e) { };
    }

    var handlePlatformContentSuccess = function (data) {
        $('#apexHelpContainer .dropdown_moreoptions .dropdown-content').hide();
        if (apex_glb.Authorize == true) {
            data = $.parseJSON(data);
        }
        if (data) {
            //amal
            apex_glb.LocStrings = window.ab_glb.LocStrings;
            if (data.LocStrings != undefined) {
                apex_glb.LocStrings = data.LocStrings;
                //$(".apex_search_area input#searchquery, .apex_search_area input#searchsubmit").attr("title", apex_glb.LocStrings.Search);
                //$(".apex_search_area input#searchquery, .apex_search_area input#searchsubmit").attr("placeholder", apex_glb.LocStrings.Search);
                $(".apex_search_area input#searchquery").attr("placeholder", apex_glb.LocStrings.Search);
                //$(".apex_search_area input#searchquery").val(apex_glb.LocStrings.Search);
                //$("#apex_header_area .back_button").html(apex_glb.LocStrings.Back);
                $("#apex_support_area .support_label").html(apex_glb.LocStrings.Support);
                $('#apexHelpContainer .dropdown_moreoptions').attr("title", apex_glb.LocStrings.Options);
                $("#apexHelpContainer .apex_header span.close_button").attr("title", apex_glb.LocStrings.Close);
                //$('#newWindowId').html(apex_glb.LocStrings.OpenNewWindow);
                $('#apexHelpContainer .dropdown_moreoptions a#homeImage span#homeText').html(apex_glb.LocStrings.Home);
                $('#apexHelpContainer .dropdown_moreoptions a#newToBingAds').html(apex_glb.LocStrings.NewToAdvertising);
                $('#apexHelpContainer .dropdown_moreoptions a#videoGallery').html(apex_glb.LocStrings.VideoGallery);
                $('#apexHelpContainer .dropdown_moreoptions a#spinOffWindow span#browserText').html(apex_glb.LocStrings.OpenNewWindow);
                $('#apexHelpContainer .dropdown_moreoptions a#copyTopic span#copyTopicText').html(apex_glb.LocStrings.CopyUrl);
                $("#apexHelpContainer .apex_search_area span.back_button").attr('title', apex_glb.LocStrings.Back);
                $("#apexHelpContainer .apex_search_area span.dropdown_moreoptions").attr('title', apex_glb.LocStrings.MoreOptions);
                $('#apexHelpContainer').addClass(apex_glb.Project.toLowerCase());

                if (apex_glb.Project.toLowerCase() == 'ucm_secured') {
                    handleUCMDropdownUpdate();
                }
                else if (apex_glb.Project.toLowerCase() == 'digital_marketing') {
                    handleDMCDropdownUpdate();
                }
                else if (apex_glb.Project.toLowerCase() == 'pubcenter_v4') {
                    $('#apexHelpContainer .dropdown_moreoptions  a#homeImage').removeAttr('query');
                }
                if (data.HeaderNavItems != undefined && data.HeaderNavItems != null && data.HeaderNavItems.length == 1) {
                    $("#apex_support_area .support").attr('url', data.HeaderNavItems[0].URL);
                }
                else {
                    $("#apex_support_area").hide();
                }
            }
            var html = '', htmlRelated = '';
            $('#apex_content_title').html('');
            if (window.apex_glb.APIController == "apexapi") {
                if (data.IsSearchResults == true) {
                    html = buildContentRows(data.Topics, 3);
                    if (html == '') {
                        $('#apex_content_title').html('');
                        html = data.Content != null ? data.Content.Content : data.Content;
                    }
                } else {
                    $(".apex_search_area input#searchquery").val(apex_glb.LocStrings.Search);
                    //$('.apex_search_area input#searchquery').focus();
                    html = buildContent(data);
                }
            } else {
                if (data.Topics != null) {
                    var topics = [];
                    $.each(data.Topics, function (i, val) {
                        topics = topics.concat(val);
                    });
                    html = buildContentRows(topics, 3);
                    if (html == '') {
                        $('#apex_content_title').html('');
                        html = data.Content != null ? data.Content.Content : data.Content;
                    }
                } else {
                    $(".apex_search_area input#searchquery").val(apex_glb.LocStrings.Search);
                    //$('.apex_search_area input#searchquery').focus();
                    html = buildContent(data);
                }
            }

            // Update dialog title for screen reader
            if (data.Content != null && data.Content.Title != null) {      
                $(railHtmlRoot).attr('aria-label', data.Content.Title);
            }
            else {
                $(railHtmlRoot).attr('aria-label', apex_glb.LocStrings.FloatingHelpPanel);
            }

            bindContentClickEvents();
            //var rowItems = [];
            //var index = 0;
            //var articles = buildContentRows(data.Topics, 2);
            //var videos = buildContentRows(data.Videos, 1);
            //var tours = buildContentRows(data.Tours, 0);
            //if (tours != '') rowItems[index++] = tours;
            //if (videos != '') rowItems[index++] = videos;
            //if (articles != '') rowItems[index++] = articles;

            $('#apexHelpContainer ' + window.ab_glb.ContentRootElement).html('');
            //html = $(rowItems.join('')).appendTo($('#railContent'));
            $('#apexHelpContainer ' + window.ab_glb.ContentRootElement).html(html);
            var apexCls = apex_glb.Project.toLowerCase();
            $('#apexHelpContainer ' + window.ab_glb.ContentRootElement + ' #cntnt').removeClass(apexCls).addClass(apexCls);

            //tooltip
            $('a.GLOSSARY_LINK').addClass("tooltip").removeClass("ONCLICK");
            $('a.GLOSSARY_LINK').removeAttr('onmouseover').removeAttr('href').removeAttr('onmouseout').removeAttr('onclick');
            $.each($('a.GLOSSARY_LINK'), function (i, v) {
                try {
                    var title = $(v).attr('title');
                    var span = '<span class="tooltiptext">' + title.trim() + '</span>';
                    $(v).after(span);
                }
                catch (ex) { }
            });
            $('a.GLOSSARY_LINK').removeAttr('title');

            //$("a.GLOSSARY_LINK").mouseover(function (e) {
            //    if (e.preventDefault) { e.preventDefault(); }
            //    if (e.stopPropagation) { e.stopPropagation(); }
            //    var top = ($(e.target).position().top + 20) + 'px';
            //    $(e.target).next().css('top', top );

            //}).mouseout(function (e) {
            //   // $(e.target).children().hide();
            //});;

            if ($('#apexHelpContainer ' + window.ab_glb.ContentRootElement + ' #related_articles').length == 1) {
                htmlRelated = buildRelatedArticlesRows(data);;
                $('#apexHelpContainer ' + window.ab_glb.ContentRootElement + ' #related_articles').html(htmlRelated);
                $("#apexHelpContainer " + window.ab_glb.ContentRootElement + " #related_articles #see_more_text").html(apex_glb.LocStrings.SeeMore);
            }
            if (this.indexValue == 0 || $('#apexHelpContainer ' + window.ab_glb.ContentRootElement).is(':visible')) {
                showHelp(true);
                var sessionQuery = ApexCookieHandler.getCookie($('#railHelpInputs').attr('ApexSessionId'));
                if (sessionQuery != null) {
                    var qry = [];
                    qry = sessionQuery.split('~');
                    query = qry[0];
                    if (isRefreshed == false) {
                        $('#apexHelpContainer ' + window.ab_glb.ContentRootElement + ' #cntnt').scrollTop(qry[1]);
                        $.each(qry, function (key, value) { if (key > 1) $('#apexHelpContainer ' + window.ab_glb.ContentRootElement + ' #' + value).trigger('click') });
                        isRefreshed = true;
                    }
                }
                ApexCookieHandler.setCookie($('#railHelpInputs').attr('ApexSessionId'), apex_glb.CurrentQuery);
            }
            addContentForBackButton(html, htmlRelated);
            loadOnDemandContent();

            // with vanilla JS!
            // Ps.initialize(document.getElementById('Demo'));

            $(".apex_search_area input#searchquery").focus();
            $.fn.ApexDropDown();
            updateUrlPaths();
            $('#cntnt').scroll(function (e) {
                var ids = [];
                ids[0] = apex_glb.CurrentQuery;
                ids[1] = $('#cntnt').scrollTop();
                $.each($('.expando-head-active'), function (key, value) { ids[key + 2] = $(value).attr('id'); });
                var idval = ids.join('~');
                ApexCookieHandler.setCookie($('#railHelpInputs').attr('ApexSessionId'), idval);
                //if (window.console && window.console.log)
                //    window.console.log('Scroll Top  ' + $('#cntnt').scrollTop() + '  ' + idval);
            });
            getLiveChatString();
            ApexTabHandler.Init();
            ApexButtonHandler.Init();
        }
    };

    var handlePlatformContentFailure = function (data) {
        //alert(data);
        $('#apexHelpContainer .dropdown_moreoptions .dropdown-content').hide();
    };

    var getABContent = function (query, search, indexValue) {
        //performs GetContent

        var sessionQuery = ApexCookieHandler.getCookie($('#railHelpInputs').attr('ApexSessionId'));
        if (sessionQuery != null && apex_glb.CurrentQuery == undefined) {
            var qry = [];
            qry = sessionQuery.split('~');
            query = qry[0];
            indexValue = 0;
        }
        apex_glb.CurrentQuery = !query ? "" : query;
        var input = {
            'project': apex_glb.Project,
            'language': apex_glb.Market
        };
        if (indexValue == null || indexValue == undefined) {
            indexValue = -1;
        }
        if (search != null && search != undefined) {
            input.asRow = 's';
            input.term = query;
        }
        else {
            input.asRow = '-2';  //for nav topics calculation
            input.query = query;
        }
        var url = window.apex_glb.EndPoint + "/api/" + window.apex_glb.APIController + "/";
        if (apex_glb.Authorize == true) {
            url = "/ApexHelp/HelpContent";
            if (input.query == null) { input.query = query; }
        }
        $.ajax({
            url: url,
            data: input,
            //method: "POST",
            indexValue: indexValue,
            contentType: 'application/json',
            crossDomain: true,
            // dataType: 'jsonp',
            cache: false,
            success: handlePlatformContentSuccess,
            error: handlePlatformContentFailure,
            timeout: 60000
        });
    };

    var initializeAnswerBar = function () {
        //Build Inital Layout
        buildRailHelpLayout();
        getABContent(apex_glb.Query);
        ApexVideoHandler.Init();
        $.fn.ApexDropDown();

        //dragApexElement();
        try {
            lpMTagConfig.loadTag();
        }
        catch (e) { };
    };

    var getApexCommonsData = function (data) {
        if (data !== "") {
            var globals = data.Globals;
            if (globals.LocStrings != undefined) {
                for (var gkey in globals.LocStrings) {
                    window.ab_glb.LocStrings[gkey] = globals.LocStrings[gkey];
                }
            }
            if (globals.Product != undefined) {
                window.ab_glb.HelpProduct = globals.Product;
            }
            if (globals.Project != undefined) {
                window.ab_glb.HelpProject = globals.Project;
            }
            if (globals.Market != undefined) {
                window.ab_glb.HelpMarket = globals.Market;
            }
            if (globals.ServiceLevel != undefined) {
                window.ab_glb.HelpSku = globals.ServiceLevel;
            }
            if (globals.Language != undefined) {
                window.ab_glb.HelpLanguage = globals.Language;
            } else {
                window.ab_glb.HelpLanguage = window.ab_glb.HelpMarket;
            }
            if (data.Config != undefined && data.Config.RailConfigs != undefined) {
                ApexChromeController.GetChromeSupportingLinksAndButtons(data.Config.RailConfigs);
            }
        }
    };

    ////Temporary HACK for campaigns AsyncLoad on switching tabs //amal
    //var tabClickBindingForCampaignsAsyncLoad = function () {
    //    $('#summaryEntityTab .ui-tabs .ui-tabs-nav li').bind("click", function (e) {
    //        if (e.preventDefault) { e.preventDefault(); }
    //        $('#railhtml').html('');
    //        initializeAnswerBar();
    //    });
    //};

    var clearHistory = function (tillIndex) {
        $('#apexHelpContainer ' + window.ab_glb.ContentRootElement).html('');
        //initializeAnswerBar();
        $('#apexHelpContainer .apex_search_area .back_button').removeClass('active').addClass('disabled');
        $('#apexHelpContainer .apex_search_area .back_button').attr('aria-disabled', 'true');

        if (!$("#apexHelpContainer #apex_support_area").is(":visible") && !$("#apexHelpContainer #apexSupportOption").is(":visible")) {
            $("#apex_platform_chrome #apex_dropdown_moreoptions").unbind('keydown');
            $("#apex_platform_chrome #apex_back_button").unbind('keydown');
            var lastElementNoSupport = findLastVisibleElement($('#apexHelpContainer'));
            var firstElem = $("#apex_platform_chrome #apex_back_button").hasClass("disabled") || !$("#apex_platform_chrome #apex_back_button").is(":visible") ? $("#apex_platform_chrome #apex_dropdown_moreoptions") : $("#apex_platform_chrome #apex_back_button");
            var lastElem = $(lastElementNoSupport);
            ApexPlatform.ApexTrapFocus(firstElem, lastElem);
        }

        while (contentHistory.length > tillIndex) {
            contentHistory.pop();// Fastest
        }
    };

    var answerBarRefreshHandler = function () {
        var elem = $('#apexHelpContainer');
        if (!isVisible(elem)) {
            clearHistory(0);
            getABContent(apex_glb.Query);
        }
        if (apex_glb.Authorize == true) bindPlatformEvents();
    };

    return {
        //Methods for getting URLs
        GetRESTURL: function (path) {
            var pathname = location.pathname;
            var paths = pathname.split('/');
            var root = '/' + paths[1];
            return root + path;
        },

        //Set Root Element for Answer Bar
        SetRootElementId: function (id) {
            if ((id != undefined) && (id != null) & (id.length > 0)) {
                railHtmlRoot = '#' + id;
            }
        },

        //Get Root Element for Answer Bar
        GetRootElementId: function () {
            return railHtmlRoot;
        },


        GetViewName: function () {
            return getViewName();
        },


        Refresh: function () {
            answerBarRefreshHandler();
        },

        FindLastVisibleElement: findLastVisibleElement,

        /*Intialize Controller*/
        Init: function () {

            if (isRailBarEnabled()) {

                //Gets the attributes for Rail Help
                getGlobalHelpInformation();

                //Inject the Styles into master page
                linkStylesFromCSSFiles();

                //Get Global Values
                initializeAnswerBar();
            }
        }
    };
}();


// Just work around for ROOT's asyn way of loading JS files...  
// DO NOT REMOVE THIS FUNCTION
if (typeof docLoadCallbacks == 'undefined') {
    initializeRailController();
}

function initializeRailController() {
    $ = jQuery;

    /*Expander control*/
    (function ($, undefined) {
        $.fn.exists = function () {
            return this.length !== 0;
        };

        $.fn.ExpanderList = function (params) {

            var self = $(this);
            self.addClass("expando-list");

            self.children().each(function (index) {
                var exp = $(this);
                exp.Expander(params);
            });
        };

        $.fn.Expander = function (params) {
            var opts = $.extend({}, $.fn.Expander.defaults, params);

            var exp = $(this);
            exp.addClass("expando");
            var head = exp.children().first();
            var body = head.next();

            // head.html().wrap('<span class="head"/>');
            head.addClass("expando-head");
            head.attr("aria-expanded", "false");
            head.wrapInner('<span class="head">');


            var expanded = exp.attr("expanded") == "true";

            body.addClass("expando-body");

            $('.expando-body').attr('role', 'region');
            if (expanded && exp.prevAll(".expando").children(".expando-head-active").length == 0) {
                head.addClass("expando-head-active");
                body.addClass("expando-body-active");
                head.attr("aria-expanded", "true");
            }
            else {
                head.attr("aria-expanded", "false");
                body.hide();
            };

            head.bind("mouseenter.expander", function () {
                $(this).addClass("expando-hover");
            });
            head.bind("mouseleave.expander", function () {
                $(this).removeClass("expando-hover");
            });
            head.bind("click", function (e) {
                //event.preventDefault();
                if (e.preventDefault) { e.preventDefault(); }
                if (e.stopPropagation) { e.stopPropagation(); }
                var selfHead = $(this);
                var selfBody = $(this).next();
                var isSelf = false;

                //amal HelpController.InstrumentLink("Exp_[" + selfHead.text().trim() + "]", "17");

                if (selfHead.hasClass("expando-head-active")) {
                    isSelf = true;
                }
                var rootExpanderList = selfHead.parents(".expando-list");
                if (!rootExpanderList.exists()) {
                    rootExpanderList = selfHead.parents(".expando");
                }
                if (!opts.Multiple) {
                    rootExpanderList.find(".expando-body-active").css({ 'display': 'none' });
                    //rootExpanderList.find(".expando-body-active").slideUp("slow", function () {
                    //    // Animation complete.
                    //    rootExpanderList.find(".expando-body-active").css({ 'overflow': 'hidden' });
                    //}); //.slideUp();

                    rootExpanderList.find(".expando-body-active").removeClass("expando-body-active").addClass("expando-body");
                    rootExpanderList.find(".expando-head-active").removeClass("expando-head-active").attr("aria-expanded", "false");
                }
                else if (isSelf) {
                    //selfBody.css({ 'display': 'none' });
                    selfBody.slideUp("slow", "swing", function () { selfBody.css({ 'visiblity': 'hidden' }) });
                    //selfBody.slideUp("slow", function () {
                    //    // Animation complete.
                    //    selfBody.css({ 'overflow': 'hidden' });
                    //});
                    selfBody.removeClass("expando-body-active").addClass("expando-body");
                    selfHead.removeClass("expando-head-active").attr("aria-expanded", "false");;
                }
                if (!isSelf) {
                    selfHead.addClass("expando-head-active").attr("aria-expanded", "true");;
                    selfBody.addClass("expando-body-active");
                    selfBody.slideDown("slow", "swing");
                }

            });
        };

        $.fn.ApexDropDown = function () {
            $('.apex_dropdown_content').hide();

            if ($('.apex_dropdown_list_master').length != 0) {
                $('.apex_dropdown_list_child').hide();
                $('.apex_dropdown .apex_dropdown_list_master option[selected]').each(function (index, elem) {
                    var parent = '#' + $(elem).parent().parent().attr('id');
                    var defaultDD = $(parent + ' .apex_dropdown_list_master option[selected]').attr('ddid');

                    if (defaultDD != null) {
                        $(parent + ' .apex_dropdown_list_child').hide();
                        $(parent + ' .apex_dropdown_list_child[ddid=' + defaultDD + ']').show();

                        $(parent + ' .apex_dropdown_content div[ddid]').hide();
                        $(parent + ' .apex_dropdown_content').show();
                        var child = $(parent + ' .apex_dropdown_list_child[ddid=' + defaultDD + '] option[selected]').attr('ddid');
                        if (child) {
                            var select = parent + ' .apex_dropdown_content div[ddid="' + $(parent + ' .apex_dropdown_list_child[ddid=' + defaultDD + '] option[selected]').attr('ddid') + '"]';
                            $(parent + ' .apex_dropdown_content').hide();
                            $(select).show();
                            $($(select).parent()).show();
                        }

                    }
                });

                $('.apex_dropdown .apex_dropdown_list_master').bind('change', function (e) {
                    var parent = '#' + $(e.target).parent().attr('id');
                    var defaultDD = $(e.target.options[e.target.selectedIndex]).attr('ddid');
                    $(parent + ' .apex_dropdown_list_child').hide();
                    $(parent + ' .apex_dropdown_list_child[ddid=' + defaultDD + ']').show();

                    $(parent + ' .apex_dropdown_content div[ddid]').hide();
                    $(parent + ' .apex_dropdown_content').show();
                    var child = $(parent + ' .apex_dropdown_list_child[ddid=' + defaultDD + '] option:selected').attr('ddid');
                    if (child) {
                        var select = parent + ' .apex_dropdown_content div[ddid="' + $(parent + ' .apex_dropdown_list_child[ddid=' + defaultDD + '] option:selected').attr('ddid') + '"]';
                        $(parent + ' .apex_dropdown_content').hide();
                        $(select).show();
                        $($(select).parent()).show();
                    }
                });

                $('.apex_dropdown .apex_dropdown_list_child').bind('change', function (e) {
                    var parent = '#' + $(e.target).parent().attr('id');
                    var defaultDD = $(e.target.options[e.target.selectedIndex]).attr('ddid');
                    $(parent + ' .apex_dropdown_content div[ddid]').hide();
                    $(parent + ' .apex_dropdown_content').show();
                    var child = $(parent + ' .apex_dropdown_content div[ddid="' + defaultDD + '"]');
                    if (child) {
                        var select = parent + ' .apex_dropdown_content div[ddid="' + defaultDD + '"]';
                        $(parent + ' .apex_dropdown_content').hide();
                        $(select).show();
                        $($(select).parent()).show();
                    }
                });
            } else {
                $('.apex_dropdown .apex_dropdown_list option[selected]').each(function (index, elem) {
                    var parent = '#' + $(elem).parent().parent().attr('id');
                    var defaultDD = $(parent + ' .apex_dropdown_list option[selected]').attr('ddid');
                    if (defaultDD != null) {
                        $(parent + ' .apex_dropdown_content div[ddid]').hide();
                        $(parent + ' .apex_dropdown_content').show();
                        var select = parent + ' .apex_dropdown_content div[ddid="' + defaultDD + '"]';
                        $(select).show();
                    }
                });

                $('.apex_dropdown .apex_dropdown_list').bind('change', function (e) {
                    var parent = '#' + $(e.target).parent().attr('id');
                    $(parent + ' .apex_dropdown_content div[ddid]').hide();
                    $(parent + ' .apex_dropdown_content').show();
                    var select = parent + ' .apex_dropdown_content div[ddid="' + $(e.target.options[e.target.selectedIndex]).attr('ddid') + '"]';
                    $(select).show();
                });
            }
        };
        //
        // plugin defaults
        //
        $.fn.ExpanderList.defaults = {
            Multiple: 'false'
        };
    })(jQuery);


    /*------------ Answer Bar Plugin ----------------------*/
    //
    // create closure
    //
    (function ($) {
        //
        // plugin definition
        //
        $.fn.CreateAnswerBar = function (options) {
            var thisElem = mainpulateRootElement(this);
            debug("Apex Embed - Load was performed.");
            // build main options before element iteration
            var opts = $.extend({}, $.fn.CreateAnswerBar.defaults, options);

            // iterate and reformat each matched element
            return thisElem.each(function () {
                var $this = $(this);
                // build element specific options
                var o = $.meta ? $.extend({}, opts, $this.data()) : opts;

                $.fn.CreateAnswerBar.format($this, o);
            });
        };

        var mainpulateRootElement = function (o) {
            var id = o.attr('id');
            var thisElem = o;
            if (id == undefined || id.toLowerCase() != 'railhtml') {
                var elem = $("#railhtml");
                if (elem.length != 0) {
                    thisElem = elem;
                }
                else {
                    var inputmarkup = '<div id="railhtml" class="raildiv"></div>';
                    $(inputmarkup).appendTo($('body')[0]);
                    thisElem = $("#railhtml");
                }
            }
            return thisElem;
        };

        //
        // private function for debugging
        //
        function debug($msg) {
            if (window.console && window.console.log)
                window.console.log($msg);
        };
        //
        // define and expose our format function
        //
        $.fn.CreateAnswerBar.format = function (e, o) {

            if (o.HelpContainerId == null) {
                RailHelpController.SetRootElementId(e.attr("id"));
            }
            else {
                RailHelpController.SetRootElementId(o.HelpContainerId);
            }

            var inputmarkup = '<INPUT ID="railHelpInputs" CLASS="railHelpInputs" type="hidden"></INPUT>';
            $(inputmarkup).insertBefore(e);
            var prefix = o.Project;
            if (prefix == '' || prefix == null) prefix = o.Product;
            //$(e).hide();
            //TODO: Needs to remove this check.  This is to support backward comaptibility
            if (o.ApexAPIEndPoint == null) {
                o.ApexAPIEndPoint = o.HelpUrl;
                o.CDNEndPoint = o.HelpUrl;
            }
            var sessionId = ApexCookieHandler.getCookie("JFX_SessionId");
            if (o.Project.toLowerCase() == 'ucm_secured') {
                sessionId = null;
            } else {
                if (sessionId == null) {
                    sessionId = "ApexHelpSessionId";
                }
                else {
                    sessionId = 'apexplat_' + sessionId.replace(new RegExp('-', 'g'), '_');
                }
                sessionId = prefix + "_" + sessionId;
            }
            $('#railHelpInputs').attr('helpurl', o.ApexAPIEndPoint);
            $('#railHelpInputs').attr('cdnEndPoint', o.CDNEndPoint);
            $('#railHelpInputs').attr('Sku', o.Sku);
            $('#railHelpInputs').attr('Project', o.Project);
            $('#railHelpInputs').attr('Product', o.Product);
            $('#railHelpInputs').attr('Market', o.Market);
            $('#railHelpInputs').attr('Language', o.Language);
            $('#railHelpInputs').attr('ViewName', '');
            $('#railHelpInputs').attr('Enable', o.Enable);
            $('#railHelpInputs').attr('InitController', o.InitController);
            $('#railHelpInputs').attr('SupportMarket', o.SupportMarket);
            $('#railHelpInputs').attr('HelpContainerId', o.HelpContainerId);
            $('#railHelpInputs').attr('ApexSessionId', sessionId);
            window.ab_glb.Success = o.Success;
            window.ab_glb.Failure = o.Failure;
            window.ab_glb.SupportOptions = o.SupportOptions;
            if ((o.InitController == true) || (o.InitController == "true")) {
                RailHelpController.Init();
            }
        };
        //
        // plugin defaults
        //
        $.fn.CreateAnswerBar.defaults = {
            HelpUrl: 'http://adhelpdev02/',
            ApexAPIEndPoint: null,
            CDNEndPoint: 'http://static.adcenterhelp.microsoft.com',
            Sku: 'SelfServe',
            Project: '',
            Product: '',
            Market: 'en-US',
            Enable: 'true',
            Language: '',
            InitController: 'false',
            SupportMarket: '',
            SupportOptions: null,
            HelpContainerId: null,
            Success: null,
            Failure: null
        };
        //
        // end of closure
        //
    })(jQuery);

    /*----------- Page OnLoad Methods ---------------------*/
    $(document).ready(function () {
        var validAnswerBar = $('#railHelpInputs').attr('InitController');
        if ((validAnswerBar != undefined) && (validAnswerBar != null) && (validAnswerBar != "true")) {
            RailHelpController.Init();
        }
        if (apex_glb.Project.toLowerCase() != 'ucm_secured') {
            ApexCloseWireUpEvents();
        }
        $('#logoutLink').bind('click', function () {
            ApexCookieHandler.setCookie($('#railHelpInputs').attr('ApexSessionId'), '');
            if (window.console && window.console.log)
                window.console.log("Logout button clicked");
        });
    });

}

/* drag functionality */
var APEX_PADDING = 0;

var apex_rect;
var application_viewport = {
    bottom: 0,
    left: 0,
    right: 0,
    top: 0
}

$.fn.setCursorPosition = function (position) {
    if (this.length == 0) return this;
    return $(this).setSelection(position, position);
}

$.fn.setSelection = function (selectionStart, selectionEnd) {
    if (this.length == 0) return this;
    input = this[0];

    if (input.createTextRange) {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveEnd('character', selectionEnd);
        range.moveStart('character', selectionStart);
        range.select();
    } else if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(selectionStart, selectionEnd);
    }

    return this;
}

$.fn.focusEnd = function () {
    this.setCursorPosition(this.val().length);
    return this;
}

function dragElement(elmnt) {
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    var dragElem = '#apexHelpContainer .apex_header_area';
    var apexMouseButtonDown = false;
    var autoSuggestVisible = false;
    $(dragElem).unbind('mousedown');
    $(dragElem).bind('mousedown', function (e) {
        if (e.preventDefault) { e.preventDefault(); }
        e = e || window.event;
        //if (!(target.is('input') && target[0].id == 'searchquery')) {
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;

        autoSuggestVisible = $('#apex-suggestion-box').is(':visible');
        // store the current application_viewport and element dimensions when a drag starts
        apex_rect = elmnt.getBoundingClientRect();
        application_viewport.bottom = window.innerHeight - APEX_PADDING;
        application_viewport.left = APEX_PADDING;
        application_viewport.right = window.innerWidth - APEX_PADDING;
        application_viewport.top = APEX_PADDING;

        $('body').addClass('apex-noselect');
        apexMouseButtonDown = true;

        $(document).bind('mousemove', function (e) {
            //if (e.preventDefault) { e.preventDefault(); }
            if (apexMouseButtonDown) {
                elementDrag(e);
            }
        });
        $(document).bind('mouseup', function (e) {
            var target = $(e.target);
            if (e.preventDefault) { e.preventDefault(); }
            if (apexMouseButtonDown) {
                apexMouseButtonDown = false;
                $('body').removeClass('apex-noselect');
            }
            $(document).unbind('mouseup');
            $(document).unbind('mousemove');

            if (target.is('input') && target[0].id == 'searchquery') {
                //var str = target.val();
                //target.focus().val('').val(str);
                target.focusEnd();
            }
            if (autoSuggestVisible) {
                autoSuggestVisible = false;
                $.fn.suggestionBox.showApexSuggestions();
            }


        });
        //}
    });

    function elementDrag(e) {

        e = e || window.event;
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;

        // check to make sure the element will be within our application_viewport boundary
        var newLeft = elmnt.offsetLeft - pos1;
        var newTop = elmnt.offsetTop - pos2;

        if (newLeft < (application_viewport.left - 270)
            || newTop < (application_viewport.top - 50)
            || (newLeft + apex_rect.width) > (application_viewport.right + 250)
            || (newTop + apex_rect.height) > (application_viewport.bottom + 700)
            //|| (elmnt.offsetTop - pos2) == 0
            //|| (elmnt.offsetLeft - pos1) == 0
        ) {
            // the element will hit the boundary, do nothing...

        } else {
            // set the element's new position:
            elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
            elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }
    }
}

var apex_ValidNavigation = false;

function ApexCloseWireUpEvents() {

    window.onbeforeunload = function () {

        if (!apex_ValidNavigation) {

            ApexCookieHandler.setCookie($('#railHelpInputs').attr('ApexSessionId'), '');
            if (window.console && window.console.log)
                window.console.log("Windows On Before Unload - Apex Good Bye");
        }
    }

    window.addEventListener("beforeunload", function (e) {
        if (!apex_ValidNavigation) {

            ApexCookieHandler.setCookie($('#railHelpInputs').attr('ApexSessionId'), '');
            if (window.console && window.console.log)
                window.console.log("Windows On Before Unload - Apex Good Bye");
        }
    });

    // Attach the event keypress to exclude the F5 refresh
    $(document).bind('keypress', function (e) {
        if (e.keyCode == 116) {
            apex_ValidNavigation = true;
        }
    });

    // Attach the event click for all links in the page
    $("a").bind("click", function () {
        apex_ValidNavigation = true;
    });
    // Attach the event submit for all forms in the page
    $("form").bind("submit", function () {
        apex_ValidNavigation = true;
    });

    // Attach the event click for all inputs in the page
    $("input[type=submit]").bind("click", function () {
        apex_ValidNavigation = true;
    });

    // Attach the event click for all inputs in the page
    $("button[type=submit]").bind("click", function () {
        apex_ValidNavigation = true;
    });

}


/*-----------------------------------------------------------
//  Name: ApexTabHandler
//  Description: ApexTabHandler
//
// -------------------------------------------------------*/
ApexTabHandler = function () {
    var init = function () {
        if ($('#railContent div.apexTab').length <= 0) return false;

        $('#railContent button.apexTabLink').off('click');
        $('#railContent button.apexTabLink').on('click', function (event) {
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();

            var target = $(event.target).closest('button[class^="apexTabLink"]');
            (target).siblings().removeClass('active');
            $(target).addClass('active');
            var targetElem = $(target).attr("tabcontentid");
            $(target).parent().siblings().hide();
            $(target).parent().siblings('#' + targetElem).show();

        });

        var hadActive = false;
        $('#railContent button.apexTabLink').each(function (index) {
            if ($(this).hasClass('active')) {
                var targetElem = $(this).attr("tabcontentid");
                $('#railContent div.apexTab #' + targetElem).show();
                hadActive = true;
            }
        });

        if (hadActive == false) {
            $('#railContent button.apexTabLink')[0].addClass('active');
            $('#railContent div.apexTabContent')[0].show();
        }

        return false;
    };
    return {
        Init: init
    };

}();

/*-----------------------------------------------------------
//  Name: ApexButtonHandler
//  Description: ApexButtonHandler
//  
// -------------------------------------------------------*/
ApexButtonHandler = function () {
    var init = function () {
        if ($('#railContent div.ApexButton').length <= 0) return false;

        $('#railContent button.ApexButtonLink').off('click');
        $('#railContent button.ApexButtonLink').on('click', function (event) {
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();

            var target = $(event.target).closest('button[class^="ApexButtonLink"]');
            (target).siblings().removeClass('active');
            $(target).addClass('active');
            var targetElem = $(target).attr("buttoncontentid");
            $(target).parent().siblings().hide();
            $(target).parent().siblings('#' + targetElem).show();

        });

        var hadActive = false;
        $('#railContent button.ApexButtonLink').each(function (index) {
            if ($(this).hasClass('active')) {
                var targetElem = $(this).attr("buttoncontentid");
                $('#railContent div.ApexButton #' + targetElem).show();
                hadActive = true;
            }
        });

        if (hadActive == false) {
            $('#railContent button.ApexButtonLink')[0].addClass('active');
            $('#railContent div.ApexButtonContent')[0].show();
        }

        return false;
    };
    return {
        Init: init
    };

}();